// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom_table {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid var(--Gainsboro-Blue, #d9dee8); }

.page_row_selector select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 8px;
  padding-right: 2rem !important; }

/* Table scroler*/
/* Add this CSS to your stylesheet or style block */
.table-container {
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  /* Adjust scrollbar colors */ }

/* Style for Webkit browsers (Chrome, Safari) */
.table-container::-webkit-scrollbar {
  width: 8px;
  /* Adjust scrollbar width as needed */
  max-height: 20px; }

/* Track */
.table-container::-webkit-scrollbar-track {
  background: transparent; }

/* Handle */
.table-container::-webkit-scrollbar-thumb {
  /* Adjust scrollbar handle border radius */
  background-color: #888;
  /* Color of the scrollbar thumb */
  border-radius: 6px;
  /* Rounded corners for the thumb */
  height: 50px;
  /* Set the height of the scrollbar thumb */ }

.table-layout_custom-scrollbar::-webkit-scrollbar {
  width: 16px;
  overflow-x: auto; }

.table-layout_custom-scrollbar::-webkit-scrollbar-track {
  background: #f4f4f4; }

.table-layout_custom-scrollbar::-webkit-scrollbar-thumb {
  background: #9f9f9f; }

.checkbox_max_w {
  max-width: 25px !important; }

.PhoneInputInput:focus {
  outline: none; }

.agent_status__dropdown label {
  font-family: Roboto;
  border-radius: 30px !important;
  min-width: 150px;
  border: none;
  text-transform: capitalize;
  font-size: 20px;
  font-style: normal;
  font-weight: 400; }

.agent_status__dropdown .btn {
  height: 41px !important; }

.agent_status__dropdown .ag_online {
  --tw-bg-opacity: 1;
  background-color: rgb(0 169 37 / var(--tw-bg-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  color: #fff; }

.agent_status__dropdown .ag_offline {
  --tw-bg-opacity: 1;
  background-color: rgb(255 243 183 / var(--tw-bg-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  color: #000; }

.agent_status__dropdown .ag_break {
  --tw-bg-opacity: 1;
  background-color: rgb(199 199 199 / var(--tw-bg-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  color: #000; }

.agent_status__dropdown .menu_top_content {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
  min-height: 30px;
  border-radius: 10px 10px 0px 0px; }

.agent_status__dropdown .menu_bottom_content {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
  min-height: 30px;
  border: 1px solid #eaecf0;
  border-radius: 0px 0px 10px 10px; }

.agent_status__dropdown .menu_item {
  font-family: Roboto; }

.agent_status__dropdown .menu_item:hover {
  font-weight: 600; }

.agent_status__dropdown .menu_item {
  padding: 15px 5px 15px 30px;
  border: 1px solid #eaecf0;
  font-size: 16px; }

.user_management__dropdown .menu_top_content {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
  font-family: Roboto;
  min-height: 84px;
  border-radius: 10px 10px 0px 0px;
  padding: 10px 30px 10px 30px; }

.user_management__dropdown .menu_bottom_spacer {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  height: 30px; }

.user_management__dropdown .menu_bottom_content {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity));
  min-height: 84px;
  border: 1px solid #eaecf0;
  border-radius: 0px 0px 10px 10px; }

.user_management__dropdown .avatar {
  width: 55px;
  height: 55px; }
  .user_management__dropdown .avatar .profile-pic {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(71 85 116 / var(--tw-border-opacity)); }

.user_management__dropdown .user-details .full-name {
  font-size: 20px;
  margin-bottom: 5px; }

.user_management__dropdown .user-details .email {
  font-size: 16px; }

.user_management__dropdown .menu_item {
  font-family: Roboto; }

.user_management__dropdown .menu_item:hover {
  font-weight: 600; }

.user_management__dropdown .menu_item {
  padding: 15px 5px 15px 30px;
  border: 1px solid #eaecf0;
  font-size: 16px; }

.add_note__slider .card__container {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25); }

.drawer__note-card .toggle {
  flex-shrink: 0;
  --tglbg: #9f9f9f;
  /* Set the background color to #9f9f9f */
  background-color: #d9d9d9;
  border: #9f9f9f; }

.drawer__note-card .toggle-private {
  flex-shrink: 0;
  --tglbg: #192a51;
  /* Set the background color to #9f9f9f */
  background-color: #d9d9d9;
  border: #9f9f9f; }

.flow_builder_messenger-drawer .toggle {
  height: 20px;
  flex-shrink: 0;
  --tglbg: #9f9f9f;
  /* Set the background color to #9f9f9f */
  background-color: white;
  border: #9f9f9f; }

.flow_builder_messenger-drawer .toggle-expand {
  height: 20px;
  flex-shrink: 0;
  --tglbg: #31c178;
  /* Set the background color to #9f9f9f */
  background-color: #c8efca;
  border: #9f9f9f; }

.contact-view__container {
  height: 100%; }
  .contact-view__container .contact-view__content {
    height: 100%; }
  .contact-view__container .detail__container {
    box-shadow: 5px 0 10px rgba(0, 0, 0, 0.2);
    padding: 12px 32px 12px 32px; }
  .contact-view__container .list-view__container {
    padding: 24px; }
    .contact-view__container .list-view__container .list-view_main__btns div {
      padding: 0px 10px 5px 0px; }
    .contact-view__container .list-view__container .list-view_main__btns button {
  width: 100%;
  -moz-column-gap: 1rem;
       column-gap: 1rem; }
    .contact-view__container .list-view__container .list-view_main__btns button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity)); }
    @media (min-width: 425px) {

  .contact-view__container .list-view__container .list-view_main__btns button {
    width: 150px; } }
    .contact-view__container .list-view__container .list-view_main__btns button {
      padding: 10px;
      border-radius: 5px;
      border: 1px solid var(--Gainsboro-Blue, #d9dee8);
      background: var(--Alice-Blue, #f3f7ff); }
    .contact-view__container .list-view__container .list-view_main__btns .btn__icon-color:hover svg,
    .contact-view__container .list-view__container .list-view_main__btns .btn__icon-color:hover g {
      stroke: white !important; }
    .contact-view__container .list-view__container .list-view_main__btns .btns__icon-color:hover svg,
    .contact-view__container .list-view__container .list-view_main__btns .btns__icon-color:hover g,
    .contact-view__container .list-view__container .list-view_main__btns .btns__icon-color:hover path {
      stroke: white !important; }
    .contact-view__container .list-view__container .tab__dropdown .menu_item:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity)); }
    .contact-view__container .list-view__container .tab__dropdown .menu_item {
      padding: 10px; }
    .contact-view__container .list-view__container .tabs {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem; }
    @media (min-width: 425px) {

  .contact-view__container .list-view__container .tabs {
    row-gap: 0.25rem; } }
      .contact-view__container .list-view__container .tabs .flex {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
  row-gap: 0.5rem; }
      .contact-view__container .list-view__container .tabs button {
  width: 100%;
  -moz-column-gap: 1rem;
       column-gap: 1rem; }
      @media (min-width: 425px) {

  .contact-view__container .list-view__container .tabs button {
    width: 150px; } }
      .contact-view__container .list-view__container .tabs .btns__icon-color:hover svg,
      .contact-view__container .list-view__container .tabs .btns__icon-color:hover g,
      .contact-view__container .list-view__container .tabs .btns__icon-color:hover path {
        stroke: white !important; }
    .contact-view__container .list-view__container .contact-view__tables {
      padding: 23px 15px 32px 26px; }
    .contact-view__container .list-view__container .contact-view__filters {
      padding: 23px 15px 0px 26px; }

.chat_preview .preview__body .preview_contact__header {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25); }

.chat_preview .preview__message_body {
  margin-top: 10px; }

.previewBtns .btns__icon-color:hover svg,
.previewBtns .btns__icon-color:hover g,
.previewBtns .btns__icon-color:hover path {
  stroke: white !important; }

.tasa__widget-container {
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 1.25rem;
  min-height: 400px;
  background-color: #FFF; }
  .tasa__widget-container .tasa__widget-header {
    display: flex;
    padding: 1rem;
    color: white;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem; }
    .tasa__widget-container .tasa__widget-header .tasa__widget-avatar {
      display: inline-block;
      position: relative;
      width: 48px;
      height: 48px;
      border-radius: 100px;
      overflow: hidden;
      background-color: #ddd;
      border: 1px solid var(--Independence-Blue, #475574); }
    .tasa__widget-container .tasa__widget-header .tasa__widget-header-text {
      margin-left: 1rem; }
      .tasa__widget-container .tasa__widget-header .tasa__widget-header-text .tasa__widget-header-main-text {
        margin-bottom: 0;
        color: #fff;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal; }
      .tasa__widget-container .tasa__widget-header .tasa__widget-header-text .tasa__widget-header-sub-text {
        color: #fff;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.28px; }
    .tasa__widget-container .tasa__widget-header .tasa__widget-header-close-btn {
      margin-left: auto;
      cursor: pointer;
      background-color: transparent; }
  .tasa__widget-container .tasa__widget-chat-container {
    font-family: 'Lato';
    padding: 15px 20px 20px 20px;
    min-height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: white; }
    .tasa__widget-container .tasa__widget-chat-container .tasa__widget-spinner-container {
      display: flex;
      justify-content: center;
      /* CSS for the custom loading spinner */
      /* Rotate animation */ }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-spinner-container .tasa__widget-spinner-loading-spinner {
        border: 4px solid transparent;
        /* Transparent border */
        border-top: 4px solid #ccc;
        /* Gray border on top */
        border-radius: 50%;
        width: 24px;
        /* Adjust the size as needed */
        height: 24px;
        /* Adjust the size as needed */
        animation: spin 1s linear infinite;
        /* Rotate animation */
        animation-timing-function: steps(50);
        /* Customize the number of steps for length */
        /* Optional: Center the spinner horizontally and vertically */
        display: flex;
        justify-content: center;
        align-items: center; }

@keyframes spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }
    .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container {
      margin-bottom: 0.5rem; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble {
        display: flex;
        margin: 0.25rem; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__customer {
        display: flex;
        justify-content: flex-start; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__agent {
        display: flex;
        justify-content: flex-end; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__username {
        display: flex;
        color: var(--Independence-Blue, #475574);
        text-align: right;
        font-family: Lato;
        font-size: 12px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        margin-bottom: 3px; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__msg {
        padding: 15px 19px 15px 19px;
        max-width: -moz-fit-content;
        max-width: fit-content;
        border: 1px solid #c7c7c7;
        color: #000;
        font-family: Lato;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__msg-customer {
        border-radius: 0px 20px 20px 20px;
        border: 1px solid #c7c7c7;
        background: var(--Honeydew, #f6fff2); }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__msg-agent {
        border-radius: 20px 0px 20px 20px;
        border: 1px solid #c7c7c7;
        background: #fff; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__timestamp {
        margin-top: 0.25rem;
        color: var(--Independence-Blue, #475574);
        font-family: Lato;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: normal; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__timestamp-customer {
        display: flex;
        flex-direction: row; }
      .tasa__widget-container .tasa__widget-chat-container .tasa__widget-message-container .tasa__widget-chat-bubble__timestamp-agent {
        display: flex;
        flex-direction: row-reverse; }
  .tasa__widget-container .tasa__widget-msg-input-container {
    display: flex;
    border-top: 1px solid var(--Gainsboro-Blue, #d9dee8);
    background: var(--Lotion-Light-Gray, #fbfbfb);
    padding: 10px 20px 12px 20px; }
    .tasa__widget-container .tasa__widget-msg-input-container svg:hover path {
      color: #FFF;
      stroke: #FFF; }
    .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      /* Centering the "Send" button */ }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-attachment {
        display: flex;
        align-items: center; }
        .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-attachment .tasa__widget-clear-attachment {
          position: absolute;
          align-items: center;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.25); }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-textarea {
        width: 100% !important;
        height: 100px;
        border: 1px solid var(--Gainsboro-Blue, #d9dee8);
        background: var(--White, #fff);
        padding-top: 16px;
        padding-left: 27px;
        padding-right: 50px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        font-family: Lato; }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-textarea::-moz-placeholder {
        color: var(--Quick-Silver, #9f9f9f);
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal; }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-textarea::placeholder {
        color: var(--Quick-Silver, #9f9f9f);
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal; }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-textarea:focus {
        outline: none; }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-send-btn {
        display: flex;
        position: absolute;
        right: 0;
        padding: 1rem;
        align-items: center;
        justify-content: center; }
        .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-send-btn .tasa__widget-btn {
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f4f4f4;
          color: #ffffff;
          border-radius: 50px;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
          cursor: pointer; }
        .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-action-button-container .tasa__widget-send-btn .tasa__widget-btn:hover {
          background-color: #192a51; }
    .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-secondary-button-container {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      margin-left: 15px !important;
      justify-content: center !important;
      cursor: pointer !important;
      gap: 10px; }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-secondary-button-container .tasa__widget-home-btn,
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-secondary-button-container .tasa__widget-attachment-btn {
        width: 24px !important;
        height: 24px !important;
        padding: 5px 6px 5px 6px;
        background-color: #f4f4f4;
        color: #ffffff;
        border-radius: 50px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        transition: background-color 0.25s;
        display: table !important; }
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-secondary-button-container .tasa__widget-home-btn:hover,
      .tasa__widget-container .tasa__widget-msg-input-container .tasa__widget-secondary-button-container .tasa__widget-attachment-btn:hover {
        background-color: #192a51; }
  .tasa__widget-container .tasa__widget-footer {
    display: flex;
    align-items: center;
    padding-top: 0px;
    padding-bottom: 16px;
    background: var(--Lotion-Light-Gray, #fbfbfb);
    border-radius: 0px 0px 16px 20px;
    color: var(--Raisin-Black, #262525);
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal; }
    .tasa__widget-container .tasa__widget-footer .tasa__widget-powered-by {
      display: flex;
      flex-direction: row;
      align-items: center; }
      .tasa__widget-container .tasa__widget-footer .tasa__widget-powered-by .tasa__widget-footer-logo {
        height: 21px;
        margin-bottom: 0.25rem; }
    .tasa__widget-container .tasa__widget-footer .tasa__widget-privacy-policy-link {
      text-decoration: underline;
      cursor: pointer; }
  .tasa__widget-container .tasa__widget-footer__privacy-policy {
    justify-content: space-between;
    padding-left: 1.5rem;
    padding-right: 1.5rem; }
  .tasa__widget-container .tasa__widget-footer__no-privacy-policy {
    justify-content: center; }

.tasa_widget__attachment_svg {
  position: relative !important;
  margin: 0 !important; }

.user-cards-line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Adjust the number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden; }

.phone-input {
  border: none;
  background-color: #f2f2f2; }
  .phone-input .PhoneInputInput {
    background-color: #f2f2f2; }

.filter-node-drawer .condition .segment-criteria-heading {
  align-items: center;
  background-color: #d6e3e3;
  margin-bottom: 10px;
  font-size: 14px;
  padding: 10px;
  border-radius: 6px;
  font-weight: 700; }
  .filter-node-drawer .condition .segment-criteria-heading .segment-method-dropdown {
    background-color: transparent;
    color: #0097b7; }
  .filter-node-drawer .condition .segment-criteria-heading .segment-method-dropdown:focus {
    border-color: #31c178;
    border-radius: 2px;
    outline: 0 !important;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05), 0 0 0 2px rgba(49, 193, 120, 0.2); }

.filter-node-drawer .segment-criteria {
  align-items: center;
  font-size: 13px;
  margin-bottom: 10px; }
  .filter-node-drawer .segment-criteria .segment-criteria-criteria {
    max-width: 100px;
    height: 38px; }

.filter-node-drawer .if-not {
  margin-top: 32px;
  color: #9db5c4;
  border-top: 1px solid #d6e3e3; }

.filter-node-drawer .if-not span {
  display: inline-block;
  position: relative;
  background: #f5f7f7;
  top: -15px;
  padding-right: 6px; }

.filter-node-drawer .not-condition {
  padding: 8px 10px 8px 10px;
  border: 1px solid #b8cece;
  border-radius: 4px;
  align-items: center; }

.filter-node-drawer .not-condition span {
  color: #6c757d;
  margin-left: 5px; }

.api-request-node-drawer .heading__text {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 8px; }

.api-request-node-drawer .heading__text--capitalized {
  text-transform: capitalize;
  color: #688fa1; }

.api-request-node-drawer .heading__text--muted {
  color: #999;
  font-weight: 400; }

.api-request-node-drawer .heading .doc .doc__link {
  font-size: 12px;
  font-weight: 500;
  margin-right: 4px;
  color: #0b99b2; }

.api-request-node-drawer .heading .doc .doc__link:hover {
  color: #075b6a;
  text-decoration: underline; }

.api-request-node-drawer .request-headers .request-headers__container {
  background-color: #fff;
  padding: 18px; }

.api-request-node-drawer .request-headers .api-request-test__btn {
  display: inline-block;
  border: 1px solid #cccccc;
  padding: 8px 12px 8px 12px;
  font-weight: 700;
  font-size: 14px;
  background-color: transparent;
  margin-top: 12px; }

.api-request-node-drawer .request-headers .api-request-test__btn:hover {
  border: 1px solid #8aafaf;
  background-color: transparent; }

.api-request-node-drawer .request-headers .test-request-preview__container {
  background-color: #cfe4e4;
  padding: 12px;
  margin-top: 12px;
  border-radius: 4px;
  max-width: 100%; }
  .api-request-node-drawer .request-headers .test-request-preview__container .preview__tabs {
    background-color: #cfe4e4; }
    .api-request-node-drawer .request-headers .test-request-preview__container .preview__tabs .tab {
      background-color: #cfe4e4;
      color: #8aafaf; }
    .api-request-node-drawer .request-headers .test-request-preview__container .preview__tabs .tab-active {
      background-color: #8aafaf;
      color: #fff; }
  .api-request-node-drawer .request-headers .test-request-preview__container .response,
  .api-request-node-drawer .request-headers .test-request-preview__container .headers {
    max-width: 390px;
    max-height: 300px;
    min-height: 120px;
    overflow-y: auto;
    font-family: Consolas, monospace;
    font-size: 12px; }
  .api-request-node-drawer .request-headers .test-request-preview__container .response::-webkit-scrollbar,
  .api-request-node-drawer .request-headers .test-request-preview__container .headers::-webkit-scrollbar {
    width: 4px;
    height: 4px; }
  .api-request-node-drawer .request-headers .test-request-preview__container .response::-webkit-scrollbar-track,
  .api-request-node-drawer .request-headers .test-request-preview__container .headers::-webkit-scrollbar-track {
    background: #cfe4e4;
    /* Track color */ }
  .api-request-node-drawer .request-headers .test-request-preview__container .response::-webkit-scrollbar-thumb,
  .api-request-node-drawer .request-headers .test-request-preview__container .headers::-webkit-scrollbar-thumb {
    background: #8aafaf;
    /* Thumb color */
    border-radius: 4px;
    /* Rounded corners */ }
  .api-request-node-drawer .request-headers .test-request-preview__container .response::-webkit-scrollbar-corner {
    background: #8aafaf;
    /* Thumb color */ }
  .api-request-node-drawer .request-headers .test-request-preview__container .response::-webkit-scrollbar-thumb:hover,
  .api-request-node-drawer .request-headers .test-request-preview__container .headers::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* Thumb color on hover */ }

.api-request-node-drawer .request-body__container {
  background-color: #fff;
  padding: 18px;
  margin-top: 12px; }
  .api-request-node-drawer .request-body__container .request-body .request-body__textarea {
    width: 100%;
    height: 100px;
    border-radius: 4px;
    border: 1px solid #cccccc; }

.api-request-node-drawer .mapping-settings .mapping-setting-text--muted {
  color: #737373;
  font-size: 13px;
  margin-top: 12px; }

.create-variable__modal {
  border: 1px solid #d9dee8;
  border-radius: 8px; }
  .create-variable__modal .header {
    padding: 16px;
    font-weight: 600;
    font-size: 20px;
    font-family: PT Sans Caption;
    margin-bottom: 0px; }
  .create-variable__modal .modal-body {
    padding: 16px; }
    .create-variable__modal .modal-body .label-text {
      font-weight: 500; }
    .create-variable__modal .modal-body .label-text-alt {
      color: #007bff; }
    .create-variable__modal .modal-body .modal__input {
      height: 36px;
      padding-left: 12px;
      padding-right: 12px;
      font-size: 14px;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid #ccc; }
    .create-variable__modal .modal-body .modal__input:focus {
      border-color: #007bff;
      /* Change the border color */
      box-shadow: 0 0 0 1px #007bff;
      /* Add a box shadow */
      outline: none;
      /* Remove default outline */ }

.flow-case__form {
  padding: 8px; }
  .flow-case__form .flow-case__form-field {
    margin-bottom: 16px;
    align-items: center; }
    .flow-case__form .flow-case__form-field .form-field__row {
      font-size: 16px; }
      .flow-case__form .flow-case__form-field .form-field__row span {
        display: flex;
        flex-direction: row; }
  .flow-case__form .flow-case__form-headings {
    margin-bottom: 16px; }
    .flow-case__form .flow-case__form-headings div {
      font-weight: bold;
      align-items: center;
      display: grid;
      flex-direction: row;
      grid-template-columns: repeat(3, 1fr); }

.flow-contact__form {
  padding: 8px; }
  .flow-contact__form .flow-contact__form-field {
    margin-bottom: 16px;
    align-items: center; }
    .flow-contact__form .flow-contact__form-field .form-field__row {
      font-size: 16px; }
      .flow-contact__form .flow-contact__form-field .form-field__row span {
        display: flex;
        flex-direction: row; }
  .flow-contact__form .flow-contact__form-headings {
    margin-bottom: 16px; }
    .flow-contact__form .flow-contact__form-headings div {
      font-weight: bold;
      align-items: center;
      display: grid;
      flex-direction: row;
      grid-template-columns: repeat(3, 1fr); }

.carousel-node-drawer .title {
  margin-top: 12px; }

.carousel-node-drawer .title input {
  margin-right: 12px; }

.carousel-node-drawer .title-text {
  font-family: Lato;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: -0.02em;
  text-align: left; }

.carousel-node-drawer .title-msg {
  margin-top: 12px; }
  .carousel-node-drawer .title-msg textarea {
    width: 100%;
    border-radius: 10px;
    height: 120px; }

.carousel-node-drawer .carousel-title {
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px dotted #192a51; }
  .carousel-node-drawer .carousel-title textarea {
    height: 120px; }

.carousel-node-drawer .carousel-slides {
  margin-top: 12px; }
  .carousel-node-drawer .carousel-slides .carousel-slides__title {
    align-items: center; }
    .carousel-node-drawer .carousel-slides .carousel-slides__title .slide-title-text {
      font-family: Lato;
      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: left; }
    .carousel-node-drawer .carousel-slides .carousel-slides__title .slide-switcher {
      height: 30px;
      margin-right: 6px; }
      .carousel-node-drawer .carousel-slides .carousel-slides__title .slide-switcher .previous-slide,
      .carousel-node-drawer .carousel-slides .carousel-slides__title .slide-switcher .next-slide {
        background-color: #fff;
        border: 2px solid #192a5188;
        padding: 4px;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer; }
  .carousel-node-drawer .carousel-slides .slide {
    margin-top: 12px; }
    .carousel-node-drawer .carousel-slides .slide .slide-title-msg textarea {
      height: 80px; }
    .carousel-node-drawer .carousel-slides .slide .slide-subtitle-msg textarea {
      height: 100px;
      resize: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0; }

.flow-builder {
  min-height: 90vh;
  background: var(--Cultured-Gray, #f4f4f4);
  margin-left: 1rem; }
  .flow-builder .header {
    margin-left: auto;
    margin-right: auto;
    align-items: center;
    justify-content: space-between; }
    .flow-builder .header .profile-pic {
      height: 55px;
      width: 55px;
      border-radius: 50%; }
    .flow-builder .header .bot-details {
      margin-left: 1rem;
      color: var(--Space-Cadet-Blue, #192a51);
      font-family: Roboto;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal; }
    .flow-builder .header .action-btns {
      align-items: center; }
  .flow-builder .builder {
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    background: var(--White, #fff);
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25); }
    .flow-builder .builder .tool-bar__container {
      border-radius: 10px 0px 0px 10px;
      background: var(--Gainsboro-Blue, #d9dee8);
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);
      height: 100vh;
      padding: 8px;
      scrollbar-width: thin;
      /* Display a thin scrollbar (modern browsers) */
      scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-track-color);
      /* Define scrollbar thumb (draggable part) color */
      --scrollbar-thumb-color: rgb(25 42 81/0.7);
      /* Define scrollbar track (background) color */
      --scrollbar-track-color: #f0f0f0; }
      .flow-builder .builder .tool-bar__container .tool-option {
        display: flex;
        flex-direction: column;
        width: 90px;
        height: 90px;
        font-size: 0.75rem;
        border-radius: 0.375rem;
        margin: 0px auto 8px auto;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        padding: 5px; }
    .flow-builder .builder .tool-bar__container::-webkit-scrollbar {
      width: 6px;
      /* Set the width of the scrollbar (Webkit browsers) */ }
    .flow-builder .builder .tool-bar__container::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb-color);
      border-radius: 6px;
      /* Adjust the border-radius to control the appearance */ }
    .flow-builder .builder .tool-bar__container::-webkit-scrollbar-track {
      background-color: var(--scrollbar-track-color); }
    .flow-builder .builder .builder-container {
      border-radius: 0px 10px 10px 0px;
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25); }
      .flow-builder .builder .builder-container .filter-node {
        padding: 0.25rem;
        border-radius: 0.375rem;
        width: 250px;
        background-color: #fff; }
        .flow-builder .builder .builder-container .filter-node .filter-node__heading {
          background-color: #fde047;
          border-radius: 0.375rem;
          padding: 4px 8px 4px 8px;
          text-align: center;
          color: #ca8a04;
          font-weight: 600; }
        .flow-builder .builder .builder-container .filter-node .filter-node__criteria {
          margin-top: 6px;
          border: 1px solid #d6e3e3;
          border-radius: 6px; }
          .flow-builder .builder .builder-container .filter-node .filter-node__criteria .criteria {
            padding: 4px; }
            .flow-builder .builder .builder-container .filter-node .filter-node__criteria .criteria .criteria__heading {
              font-size: 14px; }
            .flow-builder .builder .builder-container .filter-node .filter-node__criteria .criteria .criteria-badges {
              margin-top: 10px;
              display: flex;
              flex-wrap: wrap;
              row-gap: 6px;
              gap: 6px; }
              .flow-builder .builder .builder-container .filter-node .filter-node__criteria .criteria .criteria-badges .badge-criteria,
              .flow-builder .builder .builder-container .filter-node .filter-node__criteria .criteria .criteria-badges .badge-condition {
                display: inline-block;
                border: none;
                border-radius: 6px;
                color: #716064;
                background-color: #eaeaea;
                line-height: 1.1;
                align-items: center; }
              .flow-builder .builder .builder-container .filter-node .filter-node__criteria .criteria .criteria-badges .badge-data {
                display: inline-block;
                border: none;
                border-radius: 6px;
                color: #c7254e;
                background-color: #f9f2f4;
                line-height: 1.1;
                align-items: center;
                max-width: 100%;
                /* Limit width to parent's width */
                overflow: hidden;
                /* Hide content that overflows */
                text-overflow: ellipsis;
                /* Show ellipsis for overflowed text */
                white-space: nowrap;
                /* Prevent text wrapping */ }
      .flow-builder .builder .builder-container .api-request-node {
        background-color: #fff;
        padding: 4px;
        border-radius: 6px;
        width: 250px; }
        .flow-builder .builder .builder-container .api-request-node .api-request-node__heading {
          background-color: #fca5a5;
          padding: 4px 8px 4px 8px;
          text-align: center;
          color: #dc2626;
          font-weight: 600; }
        .flow-builder .builder .builder-container .api-request-node .api-request-node__content {
          font-size: 14px;
          text-align: center;
          padding: 12px;
          color: #716064; }
          .flow-builder .builder .builder-container .api-request-node .api-request-node__content .external-api-link {
            background-color: #eaeaea;
            border-radius: 4px;
            word-wrap: break-word; }
          .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler {
            margin-top: 12px; }
            .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .success-handler,
            .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .error-handler {
              border: 1px solid #d6e3e3;
              padding: 4px 8px 4px 8px;
              border-radius: 999px; }
              .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .success-handler .handler-text,
              .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .error-handler .handler-text {
                margin-right: 24px; }
              .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .success-handler .handler-text--success,
              .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .error-handler .handler-text--success {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity)); }
              .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .success-handler .handler-text--error,
              .flow-builder .builder .builder-container .api-request-node .api-request-node__content .api-request-handler .error-handler .handler-text--error {
  --tw-text-opacity: 1;
  color: rgb(157 181 196 / var(--tw-text-opacity)); }
      .flow-builder .builder .builder-container .carousel-node {
        padding: 0.25rem;
        border-radius: 0.375rem;
        width: 250px;
        background-color: #fff; }
        .flow-builder .builder .builder-container .carousel-node .carousel-node__heading {
          background-color: #e047;
          border-radius: 0.375rem;
          padding: 4px 8px 4px 8px;
          text-align: center;
          color: #fff;
          font-weight: 600; }
        .flow-builder .builder .builder-container .carousel-node .carousel-node__content {
          font-size: 14px;
          text-align: center;
          padding: 12px;
          color: #716064; }
        .flow-builder .builder .builder-container .carousel-node .carousel-node__slide {
          margin-top: 6px;
          border: 1px solid #d6e3e3;
          border-radius: 6px; }
          .flow-builder .builder .builder-container .carousel-node .carousel-node__slide .slide {
            padding: 4px; }
            .flow-builder .builder .builder-container .carousel-node .carousel-node__slide .slide .slide__heading {
              font-size: 14px; }
              .flow-builder .builder .builder-container .carousel-node .carousel-node__slide .slide .slide__heading .slide-number {
                color: #716064;
                font-size: 12px; }

.flow-builder-drawer__container .drawer-side {
  right: 0;
  width: unset;
  left: unset; }

.flow-builder__drawer {
  --tw-shadow: 0 10px 15px -3px rgba(182, 180, 180, 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color),
    0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 red), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow); }
  .flow-builder__drawer .drawer-content {
    scrollbar-width: thin;
    /* Display a thin scrollbar (modern browsers) */
    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-track-color);
    /* Define scrollbar thumb (draggable part) color */
    --scrollbar-thumb-color: rgb(25 42 81/0.7);
    /* Define scrollbar track (background) color */
    --scrollbar-track-color: #f0f0f0; }
  .flow-builder__drawer .drawer-content::-webkit-scrollbar {
    width: 6px;
    /* Set the width of the scrollbar (Webkit browsers) */ }
  .flow-builder__drawer .drawer-content::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb-color);
    border-radius: 6px;
    /* Adjust the border-radius to control the appearance */ }
  .flow-builder__drawer .drawer-content::-webkit-scrollbar-track {
    background-color: var(--scrollbar-track-color); }
  .flow-builder__drawer .add-item__link {
    font-size: 13px;
    color: #0097b7;
    margin: 5px 0px 5px 0px;
    border-bottom: 1px dotted; }
  .flow-builder__drawer .add-item__link:hover {
    color: #004552;
    cursor: pointer; }
  .flow-builder__drawer .add-component__btn {
    display: inline-block;
    margin-top: 24px;
    width: 100%;
    border-color: rgba(11, 153, 178, 0.5);
    background-color: rgba(11, 153, 178, 0.05);
    color: #0b99b2;
    border-style: dashed; }
  .flow-builder__drawer .add-component__btn:hover {
    border-color: rgba(11, 153, 178, 0.8);
    color: #0a849a; }
  .flow-builder__drawer .drawer-delete__btn {
    cursor: pointer;
    padding: 4px; }
  .flow-builder__drawer .drawer-delete__btn:hover {
    border-radius: 50%;
    background-color: #e8eaea; }
  .flow-builder__drawer .flow-builder__input {
    font-size: 14px;
    padding-left: 8px;
    min-height: 48px;
    width: 100%;
    border-radius: 10px;
    border: 1px solid #d9dee8; }
  .flow-builder__drawer .flow-builder__input:focus {
    border-color: #007bff;
    /* Change the border color */
    box-shadow: 0 0 0 1px #007bff;
    /* Add a box shadow */
    outline: none;
    /* Remove default outline */ }

.tooltip-container {
  position: relative;
  display: inline-block;
  z-index: 999999; }

.tooltip-container::after {
  content: attr(data-tooltip);
  position: absolute;
  background: #333;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 1;
  font-size: x-small;
  display: none;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px; }

.tooltip-container:hover::after {
  display: block; }

.messenger_instance__form .code_snippet__container div {
  overflow: auto !important;
  padding: 10px; }

.contact_form .more_settings:hover path {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms;
  stroke: #fff; }

/* Remove scrollbar arrows for webkit-based browsers (Chrome) */
.tab-layout_custom-scrollbar::-webkit-scrollbar {
  width: 16px;
  overflow-x: auto; }

.tab-layout_custom-scrollbar::-webkit-scrollbar-track {
  background: #fbfbfb; }

.tab-layout_custom-scrollbar::-webkit-scrollbar-thumb {
  background: #192a51; }

.inbox_custom-scrollbar::-webkit-scrollbar {
  display: none; }

.inbox-upload_image:hover svg,
.inbox-upload_image:hover g {
  stroke: #192a51 !important; }

.inbox-emoji_picker:hover svg,
.inbox-emoji_picker:hover g {
  stroke: #192a51 !important; }

.clear-attachment-icon {
  color: black;
  font-size: 2rem;
  position: absolute;
  top: 2px;
  left: -61px;
  transform: translate(50%, -50%);
  cursor: pointer;
  z-index: 2;
  -ms-transform: translate(-50%, -50%); }

.user-Template__btn-row .btn__icon-color:hover svg,
.user-Template__btn-row .btn__icon-color:hover g {
  stroke: white !important; }

.user-Template__btn-row .template-btn__icon-color svg,
.user-Template__btn-row .template-btn__icon-color g {
  stroke: white; }

.user-Template__btn-row .case-btn__icon-color:hover svg,
.user-Template__btn-row .case-btn__icon-color:hover g,
.user-Template__btn-row .case-btn__icon-color:hover path {
  stroke: white !important; }

.active_tab path {
  stroke: #fff; }

/* Remove scrollbar arrows for webkit-based browsers (Chrome) */
.chat-preview_custom-scrollbar::-webkit-scrollbar {
  width: 16px; }

.chat-preview_custom-scrollbar::-webkit-scrollbar-track {
  background: #9f9f9f; }

/* Remove scrollbar arrows for Firefox */
.chat-preview_custom-scrollbar::-webkit-scrollbar-thumb {
  background: #f4f4f4; }

.inbox_custom-scrollbar::-webkit-scrollbar {
  display: none; }

@media (max-width: 1366px) {
  .case-Management__hide-on-large-screens {
    display: none; } }

@media (min-width: 1366px) {
  .case-Management-drawer__hide-on-large-screens {
    display: none; } }

.role_permission__form .main-heading {
  color: var(--Space-Cadet-Blue, #192a51);
  /* Tabular_Heading_PT_Sans_Caption16 */
  font-family: PT Sans Caption;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal; }

.role_permission__form .permission-heading {
  color: var(--Space-Cadet-Blue, #192a51);
  /* Tabular_Heading_PT_Sans_Caption16 */
  font-family: PT Sans Caption;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal; }

.role-permission__container .role-permission__card {
  padding: 20px 34px 20px 34px;
  border-radius: 10px;
  background: var(--White, #fff);
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25); }

.role-permission__container .module-name {
  color: var(--Raisin-Black, #262525);
  font-family: PT Sans Caption;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal; }

.role-permission__container .role-type {
  color: var(--Raisin-Black, #262525);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.32px; }

.role-permission__container .role__card {
  padding: 20px 5px 20px 5px; }

.layout {
  display: flex; }

.main-container {
  display: flex;
  flex: 1;
  margin-top: 80px; }

.navbar {
  height: 80px;
  position: fixed !important;
  z-index: 500; }

.content {
  flex-grow: 1;
  overflow-y: auto;
  background-color: #f4f4f4; }

.sidebar.bar_open {
  min-width: 17rem;
  max-width: 17rem; }

.sidebar .sidebar_content {
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: -999; }

@media (min-width: 768px) {
  .sidebar {
    min-height: calc(100vh - 80px); } }

@media (max-width: 768px) {
  .sidebar {
    height: 100vh; } }

.sidebar .nav_link {
  min-width: 240px;
  display: flex;
  cursor: default;
  align-items: center;
  border-radius: 0.75rem;
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 240 / var(--tw-bg-opacity));
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 116 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); }

.contact-view__container .list-view__container .tabs .sidebar .nav_link {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
  row-gap: 0.5rem; }

.sidebar .nav_link:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity)); }

@media (min-width: 1024px) {

  .sidebar .nav_link {
    cursor: pointer; } }

.sidebar .nav_link-sub_menu {
  min-width: 240px;
  display: flex;
  cursor: default;
  border-radius: 0.75rem;
  border-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 240 / var(--tw-bg-opacity));
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(71 85 116 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); }

.contact-view__container .list-view__container .tabs .sidebar .nav_link-sub_menu {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
  row-gap: 0.5rem; }

.sidebar .nav_link-sub_menu:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity)); }

@media (min-width: 1024px) {

  .sidebar .nav_link-sub_menu {
    cursor: pointer; } }

.sidebar .sub_menu {
  display: flex;
  cursor: default;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  padding: 0.625rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-delay: 150ms;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); }

.contact-view__container .list-view__container .tabs .sidebar .sub_menu {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
  row-gap: 0.5rem; }

@media (min-width: 1024px) {

  .sidebar .sub_menu {
    cursor: pointer; } }

.sidebar .active {
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  transition-property: none; }

.sidebar .active:hover {
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)); }

.sidebar .nav_content:hover {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms; }

.sidebar .is_active {
  --tw-bg-opacity: 1;
  background-color: rgb(25 42 81 / var(--tw-bg-opacity));
  color: #fff; }
  .sidebar .is_active svg {
    transition-delay: 25ms;
    color: #fff !important;
    stroke: #fff !important; }
  .sidebar .is_active path {
    transition-delay: 25ms;
    stroke: #fff !important;
    color: #fff !important; }

.sidebar .menu_common {
  gap: 10px;
  transition-delay: 25ms; }
  .sidebar .menu_common .icon {
    max-width: 20px; }
  .sidebar .menu_common:hover svg {
    transition-delay: 25ms;
    color: #fff !important;
    stroke: #fff !important; }
  .sidebar .menu_common:hover path {
    transition-delay: 25ms;
    stroke: #fff !important;
    color: #fff !important; }

.page {
  padding: 25px 35px; }

.public_page {
  padding: 0; }

.drawer-side {
  z-index: 999 !important; }

.overlay {
  position: relative;
  height: 100%;
  width: 100%;
  opacity: 0.1;
  transition: 0.3s ease;
  background-color: transparent; }

.overlay:hover {
  opacity: 0.9; }

.tab.tab-active:not(.tab-disabled):not([disabled]) {
  background-color: #192a51;
  color: white; }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/table.scss","webpack://./src/assets/scss/components/form.scss","webpack://./src/assets/scss/components/navbar.scss","webpack://./src/assets/scss/components/slider.scss","webpack://./src/assets/scss/components/noteCard.scss","webpack://./src/assets/scss/components/caseList.scss","webpack://./src/assets/scss/components/drawers.scss","webpack://./src/assets/scss/components/webChatWidget.scss","webpack://./src/assets/scss/components/userCard.scss","webpack://./src/assets/scss/components/phoneInput.scss","webpack://./src/assets/scss/components/flowBuilder/filterDrawer.scss","webpack://./src/assets/scss/components/flowBuilder/apiRequestDrawer.scss","webpack://./src/assets/scss/components/flowBuilder/createVariableModal.scss","webpack://./src/assets/scss/components/flowBuilder/caseComponent.scss","webpack://./src/assets/scss/components/flowBuilder/contatComponent.scss","webpack://./src/assets/scss/components/flowBuilder/carouselDrawer.scss","webpack://./src/assets/scss/components/flowBuilder.scss","webpack://./src/assets/scss/components/tooltip.scss","webpack://./src/assets/scss/views/messenger_instance.scss","webpack://./src/assets/scss/views/contact_form.scss","webpack://./src/assets/scss/views/inbox.scss","webpack://./src/assets/scss/views/completed_chats.scss","webpack://./src/assets/scss/views/cases.scss","webpack://./src/assets/scss/views/rolePermissions.scss","webpack://./src/assets/scss/layout.scss","webpack://./src/assets/scss/variables.scss","webpack://./src/assets/scss/css_override.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EAEnB,gCAAgC;EAChC,gDAAgD,EAAA;;AAGlD;EAEI,wBAAwB;EACxB,qBAAqB;EACrB,yDAAsN;EACtN,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B,EAAA;;AAIlC,iBAAA;AAEA,mDAAA;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,+CAA+C;EAC/C,4BAAA,EAA6B;;AAG/B,+CAAA;AACA;EACE,UAAU;EACV,qCAAA;EACA,gBAAgB,EAAA;;AAGlB,UAAA;AACA;EACE,uBAAuB,EAAA;;AAGzB,WAAA;AACA;EAEE,0CAAA;EACA,sBAAsB;EACtB,iCAAA;EACA,kBAAkB;EAClB,kCAAA;EACA,YAAY;EACZ,0CAAA,EAA2C;;AAG7C;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AC1DrB;EACE,0BAA0B,EAAA;;AAE5B;EACE,aAAa,EAAA;;ACTX;EAAA,mBAAM;EAEN,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAE1B,eAAe;EACf,kBAAkB;EAClB,kBATM;;AAFV;EAeI,uBAAuB,EAAA;;AAIvB;EAAA,kBAAM;EAAN,sDAAM;EAAN,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,0BAAM;EAAN,wDAAM;EACN,aADM;;AAKN;EAAA,kBAAM;EAAN,yDAAM;EAAN,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,0BAAM;EAAN,wDAAM;EACN,aADM;;AAKN;EAAA,kBAAM;EAAN,yDAAM;EAAN,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,0BAAM;EAAN,wDAAM;EACN,aADM;;AAKN;EAAA,kBAAM;EAAN,yDAAM;EAEN,gBAAgB;EAChB,kCAHM;;AAON;EAAA,kBAAM;EAAN,yDAAM;EACN,gBAAgB;EAEhB,yBAAyB;EACzB,kCAJM;;AAQN;EAAA,qBAAM;;AAAN;EAAA,kBAAM;;AAjDV;EAmDI,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe,EAAA;;AAOf;EAAA,kBAAM;EAAN,yDAAM;EAAN,mBAAM;EAEN,gBAAgB;EAChB,gCAAgC;EAChC,8BAJM;;AAQN;EAAA,kBAAM;EAAN,yDAAM;EAEN,cAFM;;AAMN;EAAA,kBAAM;EAAN,yDAAM;EACN,gBAAgB;EAEhB,yBAAyB;EACzB,kCAJM;;AAjBV;EAyBI,WAAW;EACX,YAAY,EAAA;EAGV;EAAA,iBAAM;EAAN,sBAAM;EAAN,yDAAM;;AA7BZ;EAmCM,eAAe;EACf,kBAAkB,EAAA;;AApCxB;EAwCM,eAAe,EAAA;;AAKjB;EAAA,qBAAM;;AAAN;EAAA,kBAAM;;AA7CV;EA+CI,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe,EAAA;;AC1GnB;EAGQ,+CAA+C,EAAA;;ACHvD;EAEI,cAAc;EACd,gBAAQ;EAAU,wCAAA;EAClB,yBAAyB;EACzB,eAAe,EAAA;;AALnB;EAQI,cAAc;EACd,gBAAQ;EAAU,wCAAA;EAClB,yBAAyB;EACzB,eAAe,EAAA;;AAInB;EAEI,YAAY;EACZ,cAAc;EACd,gBAAQ;EAAU,wCAAA;EAClB,uBAAuB;EACvB,eAAe,EAAA;;AANnB;EASI,YAAY;EACZ,cAAc;EACd,gBAAQ;EAAU,wCAAA;EAClB,yBAAyB;EACzB,eAAe,EAAA;;AC5BnB;EACE,YAAY,EAAA;EADd;IAII,YAAY,EAAA;EAJhB;IAQI,yCAAyC;IACzC,4BAA4B,EAAA;EAThC;IAaI,aAAa,EAAA;IAbjB;MAiBQ,yBAAyB,EAAA;IAIzB;EAAA,WAAM;EAAN,qBAAM;OAAN,kBAAM;IAAN;EAAA,kBAAM;EAAN,sDAAM;EAAN,oBAAM;EAAN,kDAAM;IAAN;;EAAA;IAAA,cAAM,EAAA;IArBd;MAuBQ,aAAa;MACb,kBAAkB;MAClB,gDAAgD;MAChD,sCAAsC,EAAA;IA1B9C;;MAgCY,wBAAwB,EAAA;IAhCpC;;;MAyCY,wBAAwB,EAAA;IAQ5B;EAAA,kBAAM;EAAN,sDAAM;EAAN,oBAAM;EAAN,kDAAM;IAjDd;MAmDQ,aAAa,EAAA;IAKf;EAAA,uBAAM;OAAN,oBAAM;IAAN;;EAAA;IAAA,kBAAM,EAAA;MAGJ;EAAA,uBAAM;OAAN,kBAAM;EAAN,iBAAM;MAIN;EAAA,WAAM;EAAN,qBAAM;OAAN,kBAAM;MAAN;;EAAA;IAAA,cAAM,EAAA;MA/Dd;;;QAsEY,wBAAwB,EAAA;IAtEpC;MA6EM,4BAA4B,EAAA;IA7ElC;MAiFM,2BAA2B,EAAA;;ACjFjC;EAGM,+CAA+C,EAAA;;AAHrD;EAQI,gBAAgB,EAAA;;AAIpB;;;EAMQ,wBAAwB,EAAA;;AClBhC;EACI,WAAW;EACX,0CAA0C;EAC1C,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB,EAAA;EAL1B;IAQQ,aAAa;IACb,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B,EAAA;IAZrC;MAeY,qBAAqB;MACrB,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,gBAAgB;MAChB,sBAAsB;MACtB,mDAAmD,EAAA;IAtB/D;MA0BY,iBAAiB,EAAA;MA1B7B;QA6BgB,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;MAlCnC;QAsCgB,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB,EAAA;IA3CvC;MAgDY,iBAAiB;MACjB,eAAe;MACf,6BAA6B,EAAA;EAlDzC;IAwDQ,mBAAmB;IACnB,4BAA4B;IAC5B,iBAAiB;IAEjB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB,EAAA;IA9D/B;MAiEY,aAAa;MACb,uBAAuB;MAEvB,uCAAA;MAsBA,qBAAA,EAAsB;MA1FlC;QAsEgB,6BAA6B;QAC7B,uBAAA;QACA,0BAA0B;QAC1B,uBAAA;QACA,kBAAkB;QAClB,WAAW;QACX,8BAAA;QACA,YAAY;QACZ,8BAAA;QACA,kCAAkC;QAClC,qBAAA;QACA,oCAAoC;QACpC,6CAAA;QAEA,6DAAA;QACA,aAAa;QACb,uBAAuB;QACvB,mBAAmB,EAAA;;AAIvB;EACI;IACI,uBAAuB,EAAA;EAG3B;IACI,yBAAyB,EAAA,EAAA;IAjG7C;MAuGY,qBAAqB,EAAA;MAvGjC;QA0GgB,aAAa;QACb,eAAe,EAAA;MA3G/B;QA+GgB,aAAa;QACb,2BAA2B,EAAA;MAhH3C;QAoHgB,aAAa;QACb,yBAAyB,EAAA;MArHzC;QAyHgB,aAAa;QACb,wCAAwC;QACxC,iBAAiB;QACjB,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB,EAAA;MAjIlC;QAqIgB,4BAA4B;QAC5B,2BAAsB;QAAtB,sBAAsB;QACtB,yBAAyB;QACzB,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;MA7InC;QAiJgB,iCAAiC;QACjC,yBAAyB;QACzB,oCAAoC,EAAA;MAnJpD;QAuJgB,iCAAiC;QACjC,yBAAyB;QACzB,gBAAgB,EAAA;MAzJhC;QA6JgB,mBAAmB;QACnB,wCAAwC;QACxC,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;MAnKnC;QAuKgB,aAAa;QACb,mBAAmB,EAAA;MAxKnC;QA4KgB,aAAa;QACb,2BAA2B,EAAA;EA7K3C;IAmLQ,aAAa;IACb,oDAAoD;IACpD,6CAA6C;IAC7C,4BAA4B,EAAA;IAtLpC;MA0LgB,WAAW;MACX,YAAY,EAAA;IA3L5B;MAgMY,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MA6ClB,gCAAA,EAAiC;MAhP7C;QAsMgB,aAAa;QACb,mBAAmB,EAAA;QAvMnC;UA0MoB,kBAAkB;UAClB,mBAAmB;UACnB,WAAW;UACX,YAAY;UACZ,qCAAqC,EAAA;MA9MzD;QAmNgB,sBAAsB;QACtB,aAAa;QACb,gDAAgD;QAChD,8BAA8B;QAC9B,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;QACnB,2BAA2B;QAC3B,wBAAwB;QACxB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAA;MAhOjC;QAoOgB,mCAAmC;QACnC,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;MAzOnC;QAoOgB,mCAAmC;QACnC,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB,EAAA;MAzOnC;QA6OgB,aAAa,EAAA;MA7O7B;QAkPgB,aAAa;QACb,kBAAkB;QAClB,QAAQ;QACR,aAAa;QACb,mBAAmB;QACnB,uBAAuB,EAAA;QAvPvC;UA0PoB,WAAW;UACX,YAAY;UACZ,aAAa;UACb,uBAAuB;UACvB,mBAAmB;UACnB,yBAAyB;UACzB,cAAc;UACd,mBAAmB;UACnB,yCAAyC;UACzC,eAAe,EAAA;QAnQnC;UAuQoB,yBAAyB,EAAA;IAvQ7C;MA+QY,wBAAwB;MACxB,iCAAiC;MACjC,8BAA8B;MAC9B,4BAA4B;MAC5B,kCAAkC;MAElC,0BAA0B;MAE1B,SAAS,EAAA;MAvRrB;;QA2RgB,sBAAsB;QACtB,uBAAuB;QAEvB,wBAAwB;QACxB,yBAAyB;QACzB,cAAc;QACd,mBAAmB;QACnB,yCAAyC;QACzC,kCAAkC;QAElC,yBAAyB,EAAA;MArSzC;;QA0SgB,yBAAyB,EAAA;EA1SzC;IAgTQ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,6CAA6C;IAC7C,gCAAgC;IAChC,mCAAmC;IACnC,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAA;IA3T3B;MA8TY,aAAa;MACb,mBAAmB;MACnB,mBAAmB,EAAA;MAhU/B;QAmUgB,YAAY;QACZ,sBAAsB,EAAA;IApUtC;MAyUY,0BAA0B;MAC1B,eAAe,EAAA;EA1U3B;IA+UQ,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB,EAAA;EAjV7B;IAqVQ,uBAAuB,EAAA;;AAI/B;EACI,6BAA6B;EAC7B,oBAAoB,EAAA;;AC3VxB;EACI,oBAAoB;EACpB,qBAAqB;EAAE,uCAAA;EACvB,4BAA4B;EAC5B,gBAAgB,EAAA;;ACJpB;EACE,YAAY;EACZ,yBAAyB,EAAA;EAF3B;IAKI,yBAAyB,EAAA;;ACL7B;EAGM,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB,EAAA;EATtB;IAYQ,6BAA6B;IAC7B,cAAc,EAAA;EAbtB;IAiBQ,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IAErB,kFAAkF,EAAA;;AArB1F;EA2BI,mBAAmB;EACnB,eAAe;EACf,mBAAmB,EAAA;EA7BvB;IAgCM,gBAAgB;IAChB,YAAY,EAAA;;AAjClB;EAsCI,gBAAgB;EAChB,cAAc;EACd,6BAA6B,EAAA;;AAxCjC;EA2CI,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB,EAAA;;AA/CtB;EAmDI,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB,EAAA;;AAtDvB;EA0DI,cAAc;EACd,gBAAgB,EAAA;;AC3DpB;EAEI,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAJtB;EAQI,0BAA0B;EAC1B,cAAc,EAAA;;AATlB;EAaI,WAAW;EACX,gBAAgB,EAAA;;AAdpB;EAoBQ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAA;;AAvBtB;EA2BQ,cAAc;EACd,0BAA0B,EAAA;;AA5BlC;EAmCM,sBAAsB;EACtB,aAAa,EAAA;;AApCnB;EAwCM,qBAAqB;EACrB,yBAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB,EAAA;;AA9CtB;EAkDM,yBAAyB;EACzB,6BAA6B,EAAA;;AAnDnC;EAuDM,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe,EAAA;EA3DrB;IA8DQ,yBAAyB,EAAA;IA9DjC;MAiEU,yBAAyB;MACzB,cAAc,EAAA;IAlExB;MAsEU,yBAAyB;MACzB,WAAW,EAAA;EAvErB;;IA6EQ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe,EAAA;EAlFvB;;IAuFQ,UAAU;IACV,WAAW,EAAA;EAxFnB;;IA6FQ,mBAAmB;IAAE,gBAAA,EAAiB;EA7F9C;;IAkGQ,mBAAmB;IAAE,gBAAA;IACrB,kBAAkB;IAAE,oBAAA,EAAqB;EAnGjD;IAuGQ,mBAAmB;IAAE,gBAAA,EAAiB;EAvG9C;;IA4GQ,gBAAgB;IAAE,yBAAA,EAA0B;;AA5GpD;EAkHI,sBAAsB;EACtB,aAAa;EACb,gBAAgB,EAAA;EApHpB;IAwHQ,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAiC,EAAA;;AA3HzC;EAkIM,cAAc;EACd,eAAe;EACf,gBAAgB,EAAA;;ACpItB;EACE,yBAAoC;EACpC,kBAAkB,EAAA;EAFpB;IAKI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB,EAAA;EATtB;IAaI,aAAa,EAAA;IAbjB;MAgBM,gBAAgB,EAAA;IAhBtB;MAoBM,cAAc,EAAA;IApBpB;MAwBM,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;MACnB,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,sBAAsB,EAAA;IA9B5B;MAkCM,qBAAqB;MAAE,4BAAA;MACvB,6BAA6B;MAAE,qBAAA;MAC/B,aAAa;MAAE,2BAAA,EAA4B;;ACpCjD;EACE,YAAY,EAAA;EADd;IAII,mBAAmB;IACnB,mBAAmB,EAAA;IALvB;MAQM,eAAe,EAAA;MARrB;QAUQ,aAAa;QACb,mBAAmB,EAAA;EAX3B;IAiBI,mBAAmB,EAAA;IAjBvB;MAoBM,iBAAiB;MACjB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,qCAAqC,EAAA;;ACxB3C;EACE,YAAY,EAAA;EADd;IAII,mBAAmB;IACnB,mBAAmB,EAAA;IALvB;MAQM,eAAe,EAAA;MARrB;QAUQ,aAAa;QACb,mBAAmB,EAAA;EAX3B;IAiBI,mBAAmB,EAAA;IAjBvB;MAoBM,iBAAiB;MACjB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,qCAAqC,EAAA;;ACxB3C;EAEI,gBAAgB,EAAA;;AAFpB;EAMI,kBAAkB,EAAA;;AANtB;EAUI,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB,EAAA;;AAfpB;EAmBI,gBAAgB,EAAA;EAnBpB;IAsBM,WAAW;IACX,mBAAmB;IACnB,aAAa,EAAA;;AAxBnB;EA6BI,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC,EAAA;EA/BrC;IAkCM,aAAa,EAAA;;AAlCnB;EAuCI,gBAAgB,EAAA;EAvCpB;IA0CM,mBAAmB,EAAA;IA1CzB;MA6CQ,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB,EAAA;IAlDxB;MAsDQ,YAAY;MACZ,iBAAiB,EAAA;MAvDzB;;QA2DU,sBAAsB;QACtB,2BAA2B;QAC3B,YAAY;QAEZ,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe,EAAA;EArEzB;IA2EM,gBAAgB,EAAA;IA3EtB;MA+EU,YAAY,EAAA;IA/EtB;MAqFU,aAAa;MACb,YAAY;MACZ,4BAA4B;MAC5B,6BAA6B,EAAA;;AChFvC;EACE,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB,EAAA;EAHnB;IAMI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;IATlC;MAYM,YAAY;MACZ,WAAW;MACX,kBAAkB,EAAA;IAdxB;MAkBM,iBAAiB;MAEjB,uCAAuC;MACvC,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB,EAAA;IAzBzB;MA6BM,mBAAmB,EAAA;EA7BzB;IAkCI,iBAAiB;IACjB,kBAAkB;IAElB,mBAAmB;IACnB,8BAA8B;IAE9B,+CAA+C,EAAA;IAxCnD;MA2CM,gCAAgC;MAChC,0CAA0C;MAC1C,+CAA+C;MAC/C,aAAa;MACb,YAAY;MAEZ,qBAAqB;MAAE,+CAAA;MACvB,0EAA0E;MAE1E,kDAAA;MACA,0CAAwB;MAExB,8CAAA;MACA,gCAAwB,EAAA;MAxD9B;QA2DQ,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,yBAAyB;QACzB,eAAe;QACf,mBAAmB;QACnB,uBAAuB;QACvB,YAAY,EAAA;IArEpB;MA0EM,UAAU;MAAE,qDAAA,EAAsD;IA1ExE;MA8EM,8CAA8C;MAC9C,kBAAkB;MAAE,uDAAA,EAAwD;IA/ElF;MAmFM,8CAA8C,EAAA;IAnFpD;MAuFM,gCAAgC;MAChC,+CAA+C,EAAA;MAxFrD;QA2FQ,gBAAgB;QAChB,uBAAuB;QACvB,YAAY;QACZ,sBAAsB,EAAA;QA9F9B;UAiGU,yBAAmC;UACnC,uBAAuB;UACvB,wBAAwB;UACxB,kBAAkB;UAClB,cAAuB;UACvB,gBAAgB,EAAA;QAtG1B;UA0GU,eAAe;UACf,yBAAyB;UACzB,kBAAkB,EAAA;UA5G5B;YA+GY,YAAY,EAAA;YA/GxB;cAkHc,eAAe,EAAA;YAlH7B;cAqHc,gBAAgB;cAChB,aAAa;cACb,eAAe;cACf,YAAY;cACZ,QAAQ,EAAA;cAzHtB;;gBA6HgB,qBAAqB;gBACrB,YAAY;gBACZ,kBAAkB;gBAClB,cAAc;gBACd,yBAAyB;gBACzB,gBAAgB;gBAChB,mBAAmB,EAAA;cAnInC;gBAuIgB,qBAAqB;gBACrB,YAAY;gBACZ,kBAAkB;gBAClB,cAAc;gBACd,yBAAyB;gBACzB,gBAAgB;gBAChB,mBAAmB;gBACnB,eAAe;gBAAE,kCAAA;gBACjB,gBAAgB;gBAAE,gCAAA;gBAClB,uBAAuB;gBAAE,sCAAA;gBACzB,mBAAmB;gBAAE,0BAAA,EAA2B;MAjJhE;QAyJQ,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,YAAY,EAAA;QA5JpB;UA+JU,yBAAoC;UACpC,wBAAwB;UACxB,kBAAkB;UAClB,cAAuB;UACvB,gBAAgB,EAAA;QAnK1B;UAuKU,eAAe;UACf,kBAAkB;UAClB,aAAa;UACb,cAAc,EAAA;UA1KxB;YA6KY,yBAAyB;YACzB,kBAAkB;YAClB,qBAAqB,EAAA;UA/KjC;YAmLY,gBAAgB,EAAA;YAnL5B;;cAuLc,yBAAyB;cACzB,wBAAwB;cACxB,oBAAoB,EAAA;cAzLlC;;gBA4LgB,kBAAkB,EAAA;cAIlB;;EAAA,oBAAM;EAAN,gDAAM;cAIN;;EAAA,oBAAM;EAAN,kDAAM;MApMtB;QA4MQ,gBAAgB;QAChB,uBAAuB;QACvB,YAAY;QACZ,sBAAsB,EAAA;QA/M9B;UAkNU,uBAAuB;UACvB,uBAAuB;UACvB,wBAAwB;UACxB,kBAAkB;UAClB,WAAW;UACX,gBAAgB,EAAA;QAvN1B;UA2NU,eAAe;UACf,kBAAkB;UAClB,aAAa;UACb,cAAc,EAAA;QA9NxB;UAkOU,eAAe;UACf,yBAAyB;UACzB,kBAAkB,EAAA;UApO5B;YAuOY,YAAY,EAAA;YAvOxB;cA0Oc,eAAe,EAAA;cA1O7B;gBA6OgB,cAAc;gBACd,eAAe,EAAA;;AAU/B;EAEI,QAAQ;EACR,YAAY;EACZ,WAAW,EAAA;;AAIf;EACE,uFAAY;EACZ;yCAAoB;EAEpB,qGACkB,EAAA;EALpB;IAQI,qBAAqB;IAAE,+CAAA;IACvB,0EAA0E;IAE1E,kDAAA;IACA,0CAAwB;IAExB,8CAAA;IACA,gCAAwB,EAAA;EAf5B;IAmBI,UAAU;IAAE,qDAAA,EAAsD;EAnBtE;IAuBI,8CAA8C;IAC9C,kBAAkB;IAAE,uDAAA,EAAwD;EAxBhF;IA4BI,8CAA8C,EAAA;EA5BlD;IAgCI,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,yBAAyB,EAAA;EAnC7B;IAuCI,cAAc;IACd,eAAe,EAAA;EAxCnB;IA4CI,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,qCAAqC;IACrC,0CAA0C;IAC1C,cAAc;IACd,oBAAoB,EAAA;EAlDxB;IAsDI,qCAAqC;IACrC,cAAc,EAAA;EAvDlB;IA2DI,eAAe;IACf,YAAY,EAAA;EA5DhB;IAgEI,kBAAkB;IAClB,yBAAyB,EAAA;EAjE7B;IAqEI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,yBAAyB,EAAA;EA1E7B;IA8EI,qBAAqB;IAAE,4BAAA;IACvB,6BAA6B;IAAE,qBAAA;IAC/B,aAAa;IAAE,2BAAA,EAA4B;;ACxV/C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe,EAAA;;AAGjB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB,EAAA;;AAGvB;EACE,cAAc,EAAA;;AC3BhB;EAGY,yBAAyB;EACzB,aAAa,EAAA;;ACDnB;EAAA,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,wDAAM;EAAN,yBAAM;EACN,cADM;;ACHZ,+DAAA;AACA;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;AAGf;;EAIM,0BAA0B,EAAA;;AAKhC;;EAIM,0BAA0B,EAAA;;AAKhC;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,UAAU;EACV,oCAAoC,EAAA;;AAGtC;;EAKQ,wBAAwB,EAAA;;AALhC;;EAYM,aAAa,EAAA;;AAZnB;;;EAoBQ,wBAAwB,EAAA;;AAMhC;EAEI,YAAY,EAAA;;AC5EhB,+DAAA;AACA;EACE,WAAW,EAAA;;AAGb;EACE,mBAAmB,EAAA;;AAGrB,wCAAA;AACA;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;ACff;EACE;IACE,aAAa,EAAA,EACd;;AAGH;EACE;IACE,aAAa,EAAA,EACd;;ACTH;EAEI,uCAAuC;EAEvC,sCAAA;EACA,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AATvB;EAaI,uCAAuC;EACvC,sCAAA;EACA,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAIvB;EAEI,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;EAC9B,+CAA+C,EAAA;;AALnD;EAQI,mCAAmC;EACnC,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;;AAbvB;EAiBI,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,EAAA;;AAvB3B;EA2BI,0BAA0B,EAAA;;AClD9B;EACE,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,OAAO;EACP,gBAAgB,EAAA;;AAGlB;EACE,YCXmB;EDYnB,0BAA0B;EAC1B,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EAEI,gBAAgB;EAChB,gBAAgB,EAAA;;AAHpB;EAOI,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAA;;AAGf;EAbF;IAcI,8BAA4C,EAAA,EAwE/C;;AArEC;EAjBF;IAkBI,aAAa,EAAA,EAoEhB;;AAtFD;EAsBI,gBAAgB;EAChB,aAAM;EAAN,eAAM;EAAN,mBAAM;EAAN,sBAAM;EAAN,iBAAM;EAAN,kBAAM;EAAN,yDAAM;EAAN,qBAAM;EAAN,sBAAM;EAAN,qBAAM;EAAN,wBAAM;EAAN,gBAAM;EAAN,oBAAM;EAAN,8CAAM;EAAN,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,0BAAM;EAAN,wDAAM,EAAA;;AAAN;EAAA,uBAAM;OAAN,kBAAM;EAAN,iBAAM;;AAAN;EAAA,kBAAM;EAAN,sDAAM;EAAN,oBAAM;EAAN,kDAAM;;AAAN;;EAAA;IAAA,iBAAM,EAAA;;AAvBV;EA2BI,gBAAgB;EAChB,aAAM;EAAN,eAAM;EAAN,sBAAM;EAAN,iBAAM;EAAN,kBAAM;EAAN,yDAAM;EAAN,qBAAM;EAAN,sBAAM;EAAN,qBAAM;EAAN,wBAAM;EAAN,gBAAM;EAAN,oBAAM;EAAN,8CAAM;EAAN,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,0BAAM;EAAN,wDAAM,EAAA;;AAAN;EAAA,uBAAM;OAAN,kBAAM;EAAN,iBAAM;;AAAN;EAAA,kBAAM;EAAN,sDAAM;EAAN,oBAAM;EAAN,kDAAM;;AAAN;;EAAA;IAAA,iBAAM,EAAA;;AAIN;EAAA,aAAM;EAAN,eAAM;EAAN,+BAAM;EAAN,gCAAM;EAAN,iBAAM;EAAN,gBAAM;EAAN,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,uBAAM;EAAN,0BAAM;EAAN,0DAAM;;AAAN;EAAA,uBAAM;OAAN,kBAAM;EAAN,iBAAM;;AAAN;;EAAA;IAAA,iBAAM,EAAA;;AAIN;EAAA,kBAAM;EAAN,sDAAM;EAAN,oBAAM;EAAN,gDAAM;EAAN,2BAAM;;AAAN;EAAA,sBAAM;EAAN,iMAAM;;AAIN;EAAA,0BAAM;EAAN,+LAAM;EAAN,gKAAM;EAAN,wJAAM;EAAN,iLAAM;EAAN,wDAAM;EAAN,2BAAM;;AAIN;EAAA,kBAAM;EAAN,sDAAM;EACN,aADM;EA5CV;IAiDM,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB,EAAA;EAnD7B;IAwDM,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB,EAAA;;AA1D5B;EA+DI,SAAS;EACT,sBAAsB,EAAA;EAhE1B;IAmEM,eAAe,EAAA;EAnErB;IAyEQ,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB,EAAA;EA3E/B;IAgFQ,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB,EAAA;;AAM9B;EACE,kBAAkB,EAAA;;AAGpB;EACE,UAAU,EAAA;;AEnHZ;EACE,uBAAuB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,6BAA6B,EAAA;;AAG/B;EACE,YAAY,EAAA;;AAGd;EACE,yBAAyB;EACzB,YAAY,EAAA","sourcesContent":[".custom_table {\n  display: block;\n  overflow-x: auto;\n  white-space: nowrap;\n\n  border-radius: 10px 10px 0px 0px;\n  border: 1px solid var(--Gainsboro-Blue, #d9dee8);\n}\n\n.page_row_selector {\n  select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n    background-repeat: no-repeat;\n    background-position-x: 100%;\n    background-position-y: 8px;\n    padding-right: 2rem !important;\n  }\n}\n\n/* Table scroler*/\n\n/* Add this CSS to your stylesheet or style block */\n.table-container {\n  overflow-y: scroll;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n  /* Adjust scrollbar colors */\n}\n\n/* Style for Webkit browsers (Chrome, Safari) */\n.table-container::-webkit-scrollbar {\n  width: 8px;\n  /* Adjust scrollbar width as needed */\n  max-height: 20px;\n}\n\n/* Track */\n.table-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n.table-container::-webkit-scrollbar-thumb {\n  border-radius: 20px;\n  /* Adjust scrollbar handle border radius */\n  background-color: #888;\n  /* Color of the scrollbar thumb */\n  border-radius: 6px;\n  /* Rounded corners for the thumb */\n  height: 50px;\n  /* Set the height of the scrollbar thumb */\n}\n\n.table-layout_custom-scrollbar::-webkit-scrollbar {\n  width: 16px;\n  overflow-x: auto;\n}\n\n.table-layout_custom-scrollbar::-webkit-scrollbar-track {\n  background: #f4f4f4;\n}\n\n.table-layout_custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #9f9f9f;\n}\n",".input_group__phone_code {\n  // max-width: 20px;\n}\n\n.input_group__phone_code__container {\n}\n\n.checkbox_max_w {\n  max-width: 25px !important;\n}\n.PhoneInputInput:focus {\n  outline: none;\n}\n",".agent_status__dropdown {\n  label {\n    @apply font-lato;\n\n    border-radius: 30px !important;\n    min-width: 150px;\n    border: none;\n    text-transform: capitalize;\n\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n  }\n\n  .btn {\n    height: 41px !important;\n  }\n\n  .ag_online {\n    @apply bg-northTexasGreen transition ease-in-out duration-200;\n    color: #fff;\n  }\n\n  .ag_offline {\n    @apply bg-blondYellow transition ease-in-out duration-200;\n    color: #000;\n  }\n\n  .ag_break {\n    @apply bg-chineseSilver transition ease-in-out duration-200;\n    color: #000;\n  }\n\n  .menu_top_content {\n    @apply bg-culturedGray;\n\n    min-height: 30px;\n    border-radius: 10px 10px 0px 0px;\n  }\n\n  .menu_bottom_content {\n    @apply bg-culturedGray;\n    min-height: 30px;\n\n    border: 1px solid #eaecf0;\n    border-radius: 0px 0px 10px 10px;\n  }\n\n  .menu_item {\n    @apply font-lato hover:font-semibold;\n\n    padding: 15px 5px 15px 30px;\n    border: 1px solid #eaecf0;\n    font-size: 16px;\n  }\n}\n\n.user_management__dropdown {\n\n  .menu_top_content {\n    @apply font-lato bg-culturedGray;\n\n    min-height: 84px;\n    border-radius: 10px 10px 0px 0px;\n    padding: 10px 30px 10px 30px;\n  }\n\n  .menu_bottom_spacer {\n    @apply bg-white;\n\n    height: 30px;\n  }\n\n  .menu_bottom_content {\n    @apply bg-culturedGray;\n    min-height: 84px;\n\n    border: 1px solid #eaecf0;\n    border-radius: 0px 0px 10px 10px;\n  }\n\n  .avatar {\n    width: 55px;\n    height: 55px;\n\n    .profile-pic {\n      @apply border-[1px] border-independenceBlue;\n    }\n  }\n\n  .user-details {\n    .full-name {\n      font-size: 20px;\n      margin-bottom: 5px;\n    }\n\n    .email {\n      font-size: 16px;\n    }\n  }\n\n  .menu_item {\n    @apply font-lato hover:font-semibold;\n\n    padding: 15px 5px 15px 30px;\n    border: 1px solid #eaecf0;\n    font-size: 16px;\n  }\n}",".add_note__slider {\n\n    .card__container {\n        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);\n    }\n}",".drawer__note-card {\n  .toggle {\n    flex-shrink: 0;\n    --tglbg: #9f9f9f; /* Set the background color to #9f9f9f */\n    background-color: #d9d9d9;\n    border: #9f9f9f;\n  }\n  .toggle-private {\n    flex-shrink: 0;\n    --tglbg: #192a51; /* Set the background color to #9f9f9f */\n    background-color: #d9d9d9;\n    border: #9f9f9f;\n  }\n}\n\n.flow_builder_messenger-drawer {\n  .toggle {\n    height: 20px;\n    flex-shrink: 0;\n    --tglbg: #9f9f9f; /* Set the background color to #9f9f9f */\n    background-color: white;\n    border: #9f9f9f;\n  }\n  .toggle-expand {\n    height: 20px;\n    flex-shrink: 0;\n    --tglbg: #31c178; /* Set the background color to #9f9f9f */\n    background-color: #c8efca;\n    border: #9f9f9f;\n  }\n}\n",".contact-view__container {\n  height: 100%;\n\n  .contact-view__content {\n    height: 100%;\n  }\n\n  .detail__container {\n    box-shadow: 5px 0 10px rgba(0, 0, 0, 0.2);\n    padding: 12px 32px 12px 32px;\n  }\n\n  .list-view__container {\n    padding: 24px;\n\n    .list-view_main__btns {\n      div {\n        padding: 0px 10px 5px 0px;\n      }\n\n      button {\n        @apply w-full gap-x-4 sm:w-[150px] hover:bg-spaceCadetBlue hover:text-white;\n\n        padding: 10px;\n        border-radius: 5px;\n        border: 1px solid var(--Gainsboro-Blue, #d9dee8);\n        background: var(--Alice-Blue, #f3f7ff);\n      }\n      .btn__icon-color {\n        &:hover {\n          svg,\n          g {\n            stroke: white !important;\n          }\n        }\n      }\n      .btns__icon-color {\n        &:hover {\n          svg,\n          g,\n          path {\n            stroke: white !important;\n          }\n        }\n      }\n    }\n\n    .tab__dropdown {\n      .menu_item {\n        @apply hover:bg-spaceCadetBlue hover:text-white;\n\n        padding: 10px;\n      }\n    }\n\n    .tabs {\n      @apply gap-x-2 sm:gap-y-1;\n\n      .flex {\n        @apply gap-x-2 gap-y-2;\n      }\n\n      button {\n        @apply w-full gap-x-4 sm:w-[150px];\n      }\n      .btns__icon-color {\n        &:hover {\n          svg,\n          g,\n          path {\n            stroke: white !important;\n          }\n        }\n      }\n    }\n\n    .contact-view__tables {\n      padding: 23px 15px 32px 26px;\n    }\n\n    .contact-view__filters {\n      padding: 23px 15px 0px 26px;\n    }\n  }\n}\n",".chat_preview {\n  .preview__body {\n    .preview_contact__header {\n      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);\n    }\n  }\n\n  .preview__message_body {\n    margin-top: 10px;\n  }\n}\n\n.previewBtns {\n  .btns__icon-color {\n    &:hover {\n      svg,\n      g,\n      path {\n        stroke: white !important;\n      }\n    }\n  }\n}\n",".tasa__widget-container {\n    width: 100%;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 1.25rem;\n    min-height: 400px;\n    background-color: #FFF;\n\n    .tasa__widget-header {\n        display: flex;\n        padding: 1rem;\n        color: white;\n        border-top-left-radius: 1rem;\n        border-top-right-radius: 1rem;\n\n        .tasa__widget-avatar {\n            display: inline-block;\n            position: relative;\n            width: 48px;\n            height: 48px;\n            border-radius: 100px;\n            overflow: hidden;\n            background-color: #ddd;\n            border: 1px solid var(--Independence-Blue, #475574);\n        }\n\n        .tasa__widget-header-text {\n            margin-left: 1rem;\n\n            .tasa__widget-header-main-text {\n                margin-bottom: 0;\n                color: #fff;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n            }\n\n            .tasa__widget-header-sub-text {\n                color: #fff;\n                font-size: 13px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: normal;\n                letter-spacing: -0.28px;\n            }\n        }\n\n        .tasa__widget-header-close-btn {\n            margin-left: auto;\n            cursor: pointer;\n            background-color: transparent;\n        }\n    }\n\n\n    .tasa__widget-chat-container {\n        font-family: 'Lato';\n        padding: 15px 20px 20px 20px;\n        min-height: 250px;\n        // max-height: 20rem;\n        overflow-y: auto;\n        overflow-x: hidden;\n        background-color: white;\n\n        .tasa__widget-spinner-container {\n            display: flex;\n            justify-content: center;\n\n            /* CSS for the custom loading spinner */\n            .tasa__widget-spinner-loading-spinner {\n                border: 4px solid transparent;\n                /* Transparent border */\n                border-top: 4px solid #ccc;\n                /* Gray border on top */\n                border-radius: 50%;\n                width: 24px;\n                /* Adjust the size as needed */\n                height: 24px;\n                /* Adjust the size as needed */\n                animation: spin 1s linear infinite;\n                /* Rotate animation */\n                animation-timing-function: steps(50);\n                /* Customize the number of steps for length */\n\n                /* Optional: Center the spinner horizontally and vertically */\n                display: flex;\n                justify-content: center;\n                align-items: center;\n            }\n\n            /* Rotate animation */\n            @keyframes spin {\n                0% {\n                    transform: rotate(0deg);\n                }\n\n                100% {\n                    transform: rotate(360deg);\n                }\n            }\n        }\n\n        .tasa__widget-message-container {\n            margin-bottom: 0.5rem;\n\n            .tasa__widget-chat-bubble {\n                display: flex;\n                margin: 0.25rem;\n            }\n\n            .tasa__widget-chat-bubble__customer {\n                display: flex;\n                justify-content: flex-start;\n            }\n\n            .tasa__widget-chat-bubble__agent {\n                display: flex;\n                justify-content: flex-end;\n            }\n\n            .tasa__widget-chat-bubble__username {\n                display: flex;\n                color: var(--Independence-Blue, #475574);\n                text-align: right;\n                font-family: Lato;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 800;\n                line-height: normal;\n                margin-bottom: 3px;\n            }\n\n            .tasa__widget-chat-bubble__msg {\n                padding: 15px 19px 15px 19px;\n                max-width: fit-content;\n                border: 1px solid #c7c7c7;\n                color: #000;\n                font-family: Lato;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: normal;\n            }\n\n            .tasa__widget-chat-bubble__msg-customer {\n                border-radius: 0px 20px 20px 20px;\n                border: 1px solid #c7c7c7;\n                background: var(--Honeydew, #f6fff2);\n            }\n\n            .tasa__widget-chat-bubble__msg-agent {\n                border-radius: 20px 0px 20px 20px;\n                border: 1px solid #c7c7c7;\n                background: #fff;\n            }\n\n            .tasa__widget-chat-bubble__timestamp {\n                margin-top: 0.25rem;\n                color: var(--Independence-Blue, #475574);\n                font-family: Lato;\n                font-size: 10px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: normal;\n            }\n\n            .tasa__widget-chat-bubble__timestamp-customer {\n                display: flex;\n                flex-direction: row;\n            }\n\n            .tasa__widget-chat-bubble__timestamp-agent {\n                display: flex;\n                flex-direction: row-reverse;\n            }\n        }\n    }\n\n    .tasa__widget-msg-input-container {\n        display: flex;\n        border-top: 1px solid var(--Gainsboro-Blue, #d9dee8);\n        background: var(--Lotion-Light-Gray, #fbfbfb);\n        padding: 10px 20px 12px 20px;\n\n        svg:hover {\n            path {\n                color: #FFF;\n                stroke: #FFF;\n            }\n        }\n\n        .tasa__widget-action-button-container {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            position: relative;\n\n            .tasa__widget-attachment {\n                display: flex;\n                align-items: center;\n\n                .tasa__widget-clear-attachment {\n                    position: absolute;\n                    align-items: center;\n                    width: 100%;\n                    height: 100%;\n                    background-color: rgba(0, 0, 0, 0.25);\n                }\n            }\n\n            .tasa__widget-textarea {\n                width: 100% !important;\n                height: 100px;\n                border: 1px solid var(--Gainsboro-Blue, #d9dee8);\n                background: var(--White, #fff);\n                padding-top: 16px;\n                padding-left: 27px;\n                padding-right: 50px;\n                border-radius: 15px;\n                -webkit-border-radius: 15px;\n                -moz-border-radius: 15px;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 400;\n                font-family: Lato;\n            }\n\n            .tasa__widget-textarea::placeholder {\n                color: var(--Quick-Silver, #9f9f9f);\n                font-family: Lato;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: normal;\n            }\n\n            .tasa__widget-textarea:focus {\n                outline: none;\n            }\n\n            /* Centering the \"Send\" button */\n            .tasa__widget-send-btn {\n                display: flex;\n                position: absolute;\n                right: 0;\n                padding: 1rem;\n                align-items: center;\n                justify-content: center;\n\n                .tasa__widget-btn {\n                    width: 30px;\n                    height: 30px;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    background-color: #f4f4f4;\n                    color: #ffffff;\n                    border-radius: 50px;\n                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n                    cursor: pointer;\n                }\n\n                .tasa__widget-btn:hover {\n                    background-color: #192a51;\n\n\n                }\n            }\n        }\n\n        .tasa__widget-secondary-button-container {\n            display: flex !important;\n            flex-direction: column !important;\n            align-items: center !important;\n            margin-left: 15px !important;\n            justify-content: center !important;\n\n            cursor: pointer !important;\n\n            gap: 10px;\n\n            .tasa__widget-home-btn,\n            .tasa__widget-attachment-btn {\n                width: 24px !important;\n                height: 24px !important;\n                // padding: 10px !important;\n                padding: 5px 6px 5px 6px;\n                background-color: #f4f4f4;\n                color: #ffffff;\n                border-radius: 50px;\n                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n                transition: background-color 0.25s;\n\n                display: table !important;\n            }\n\n            .tasa__widget-home-btn:hover,\n            .tasa__widget-attachment-btn:hover {\n                background-color: #192a51;\n            }\n        }\n    }\n\n    .tasa__widget-footer {\n        display: flex;\n        align-items: center;\n        padding-top: 0px;\n        padding-bottom: 16px;\n        background: var(--Lotion-Light-Gray, #fbfbfb);\n        border-radius: 0px 0px 16px 20px;\n        color: var(--Raisin-Black, #262525);\n        font-family: Lato;\n        font-size: 10px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n\n        .tasa__widget-powered-by {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n\n            .tasa__widget-footer-logo {\n                height: 21px;\n                margin-bottom: 0.25rem;\n            }\n        }\n\n        .tasa__widget-privacy-policy-link {\n            text-decoration: underline;\n            cursor: pointer;\n        }\n    }\n\n    .tasa__widget-footer__privacy-policy {\n        justify-content: space-between;\n        padding-left: 1.5rem;\n        padding-right: 1.5rem;\n    }\n\n    .tasa__widget-footer__no-privacy-policy {\n        justify-content: center;\n    }\n}\n\n.tasa_widget__attachment_svg {\n    position: relative !important;\n    margin: 0 !important;\n}",".user-cards-line-clamp-3 {\n    display: -webkit-box;\n    -webkit-line-clamp: 3; /* Adjust the number of lines to show */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n  ",".phone-input {\n  border: none;\n  background-color: #f2f2f2;\n\n  .PhoneInputInput {\n    background-color: #f2f2f2;\n  }\n}\n",".filter-node-drawer {\n  .condition {\n    .segment-criteria-heading {\n      align-items: center;\n      background-color: #d6e3e3;\n      margin-bottom: 10px;\n      font-size: 14px;\n      padding: 10px;\n      border-radius: 6px;\n      font-weight: 700;\n\n      .segment-method-dropdown {\n        background-color: transparent;\n        color: #0097b7;\n      }\n\n      .segment-method-dropdown:focus {\n        border-color: #31c178;\n        border-radius: 2px;\n        outline: 0 !important;\n        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05), 0 0 0 2px rgba(49, 193, 120, 0.2);\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05), 0 0 0 2px rgba(49, 193, 120, 0.2);\n      }\n    }\n  }\n\n  .segment-criteria {\n    align-items: center;\n    font-size: 13px;\n    margin-bottom: 10px;\n\n    .segment-criteria-criteria {\n      max-width: 100px;\n      height: 38px;\n    }\n  }\n\n  .if-not {\n    margin-top: 32px;\n    color: #9db5c4;\n    border-top: 1px solid #d6e3e3;\n  }\n  .if-not span {\n    display: inline-block;\n    position: relative;\n    background: #f5f7f7;\n    top: -15px;\n    padding-right: 6px;\n  }\n\n  .not-condition {\n    padding: 8px 10px 8px 10px;\n    border: 1px solid #b8cece;\n    border-radius: 4px;\n    align-items: center;\n  }\n\n  .not-condition span {\n    color: #6c757d;\n    margin-left: 5px;\n  }\n}\n",".api-request-node-drawer {\n  .heading__text {\n    font-size: 15px;\n    font-weight: 700;\n    margin-bottom: 8px;\n  }\n\n  .heading__text--capitalized {\n    text-transform: capitalize;\n    color: #688fa1;\n  }\n\n  .heading__text--muted {\n    color: #999;\n    font-weight: 400;\n  }\n\n  .heading {\n    .doc {\n      .doc__link {\n        font-size: 12px;\n        font-weight: 500;\n        margin-right: 4px;\n        color: #0b99b2;\n      }\n\n      .doc__link:hover {\n        color: #075b6a;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .request-headers {\n    .request-headers__container {\n      background-color: #fff;\n      padding: 18px;\n    }\n\n    .api-request-test__btn {\n      display: inline-block;\n      border: 1px solid hsl(0, 0%, 80%);\n      padding: 8px 12px 8px 12px;\n      font-weight: 700;\n      font-size: 14px;\n      background-color: transparent;\n      margin-top: 12px;\n    }\n\n    .api-request-test__btn:hover {\n      border: 1px solid #8aafaf;\n      background-color: transparent;\n    }\n\n    .test-request-preview__container {\n      background-color: #cfe4e4;\n      padding: 12px;\n      margin-top: 12px;\n      border-radius: 4px;\n      max-width: 100%;\n\n      .preview__tabs {\n        background-color: #cfe4e4;\n\n        .tab {\n          background-color: #cfe4e4;\n          color: #8aafaf;\n        }\n\n        .tab-active {\n          background-color: #8aafaf;\n          color: #fff;\n        }\n      }\n\n      .response,\n      .headers {\n        max-width: 390px;\n        max-height: 300px;\n        min-height: 120px;\n        overflow-y: auto;\n        font-family: Consolas, monospace;\n        font-size: 12px;\n      }\n\n      .response::-webkit-scrollbar,\n      .headers::-webkit-scrollbar {\n        width: 4px;\n        height: 4px;\n      }\n\n      .response::-webkit-scrollbar-track,\n      .headers::-webkit-scrollbar-track {\n        background: #cfe4e4; /* Track color */\n      }\n\n      .response::-webkit-scrollbar-thumb,\n      .headers::-webkit-scrollbar-thumb {\n        background: #8aafaf; /* Thumb color */\n        border-radius: 4px; /* Rounded corners */\n      }\n\n      .response::-webkit-scrollbar-corner {\n        background: #8aafaf; /* Thumb color */\n      }\n\n      .response::-webkit-scrollbar-thumb:hover,\n      .headers::-webkit-scrollbar-thumb:hover {\n        background: #555; /* Thumb color on hover */\n      }\n    }\n  }\n\n  .request-body__container {\n    background-color: #fff;\n    padding: 18px;\n    margin-top: 12px;\n\n    .request-body {\n      .request-body__textarea {\n        width: 100%;\n        height: 100px;\n        border-radius: 4px;\n        border: 1px solid hsl(0, 0%, 80%);\n      }\n    }\n  }\n\n  .mapping-settings {\n    .mapping-setting-text--muted {\n      color: #737373;\n      font-size: 13px;\n      margin-top: 12px;\n    }\n  }\n}\n",".create-variable__modal {\n  border: 1px solid rgb(217, 222, 232);\n  border-radius: 8px;\n\n  .header {\n    padding: 16px;\n    font-weight: 600;\n    font-size: 20px;\n    font-family: PT Sans Caption;\n    margin-bottom: 0px;\n  }\n\n  .modal-body {\n    padding: 16px;\n\n    .label-text {\n      font-weight: 500;\n    }\n\n    .label-text-alt {\n      color: #007bff;\n    }\n\n    .modal__input {\n      height: 36px;\n      padding-left: 12px;\n      padding-right: 12px;\n      font-size: 14px;\n      line-height: 32px;\n      border-radius: 4px;\n      border: 1px solid #ccc;\n    }\n\n    .modal__input:focus {\n      border-color: #007bff; /* Change the border color */\n      box-shadow: 0 0 0 1px #007bff; /* Add a box shadow */\n      outline: none; /* Remove default outline */\n    }\n  }\n}\n",".flow-case__form {\n  padding: 8px;\n\n  .flow-case__form-field {\n    margin-bottom: 16px;\n    align-items: center;\n\n    .form-field__row {\n      font-size: 16px;\n      span {\n        display: flex;\n        flex-direction: row;\n      }\n    }\n  }\n\n  .flow-case__form-headings {\n    margin-bottom: 16px;\n\n    div {\n      font-weight: bold;\n      align-items: center;\n      display: grid;\n      flex-direction: row;\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n}\n",".flow-contact__form {\n  padding: 8px;\n\n  .flow-contact__form-field {\n    margin-bottom: 16px;\n    align-items: center;\n\n    .form-field__row {\n      font-size: 16px;\n      span {\n        display: flex;\n        flex-direction: row;\n      }\n    }\n  }\n\n  .flow-contact__form-headings {\n    margin-bottom: 16px;\n\n    div {\n      font-weight: bold;\n      align-items: center;\n      display: grid;\n      flex-direction: row;\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n}\n",".carousel-node-drawer {\n  .title {\n    margin-top: 12px;\n  }\n\n  .title input {\n    margin-right: 12px;\n  }\n\n  .title-text {\n    font-family: Lato;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19px;\n    letter-spacing: -0.02em;\n    text-align: left;\n  }\n\n  .title-msg {\n    margin-top: 12px;\n\n    textarea {\n      width: 100%;\n      border-radius: 10px;\n      height: 120px;\n    }\n  }\n\n  .carousel-title {\n    align-items: center;\n    padding-bottom: 12px;\n    border-bottom: 1px dotted #192a51;\n\n    textarea {\n      height: 120px;\n    }\n  }\n\n  .carousel-slides {\n    margin-top: 12px;\n\n    .carousel-slides__title {\n      align-items: center;\n\n      .slide-title-text {\n        font-family: Lato;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 19px;\n        letter-spacing: 0em;\n        text-align: left;\n      }\n\n      .slide-switcher {\n        height: 30px;\n        margin-right: 6px;\n\n        .previous-slide,\n        .next-slide {\n          background-color: #fff;\n          border: 2px solid #192a5188;\n          padding: 4px;\n          align-items: center;\n          border-radius: 50%;\n          width: 30px;\n          height: 30px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          cursor: pointer;\n        }\n      }\n    }\n\n    .slide {\n      margin-top: 12px;\n\n      .slide-title-msg {\n        textarea {\n          height: 80px;\n        }\n      }\n\n      .slide-subtitle-msg {\n        textarea {\n          height: 100px;\n          resize: none;\n          border-bottom-left-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n\n        button {\n        }\n      }\n    }\n  }\n}\n","// components\n@import './flowBuilder/filterDrawer.scss';\n@import './flowBuilder/apiRequestDrawer.scss';\n@import './flowBuilder/createVariableModal.scss';\n@import './flowBuilder/caseComponent.scss';\n@import './flowBuilder/contatComponent.scss';\n@import './flowBuilder/carouselDrawer.scss';\n\n.flow-builder {\n  min-height: 90vh;\n  background: var(--Cultured-Gray, #f4f4f4);\n  margin-left: 1rem;\n\n  .header {\n    margin-left: auto;\n    margin-right: auto;\n    align-items: center;\n    justify-content: space-between;\n\n    .profile-pic {\n      height: 55px;\n      width: 55px;\n      border-radius: 50%;\n    }\n\n    .bot-details {\n      margin-left: 1rem;\n\n      color: var(--Space-Cadet-Blue, #192a51);\n      font-family: Roboto;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    .action-btns {\n      align-items: center;\n    }\n  }\n\n  .builder {\n    margin-left: auto;\n    margin-right: auto;\n\n    border-radius: 10px;\n    background: var(--White, #fff);\n\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);\n\n    .tool-bar__container {\n      border-radius: 10px 0px 0px 10px;\n      background: var(--Gainsboro-Blue, #d9dee8);\n      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);\n      height: 100vh;\n      padding: 8px;\n\n      scrollbar-width: thin; /* Display a thin scrollbar (modern browsers) */\n      scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-track-color);\n\n      /* Define scrollbar thumb (draggable part) color */\n      --scrollbar-thumb-color: rgb(25 42 81/0.7);\n\n      /* Define scrollbar track (background) color */\n      --scrollbar-track-color: #f0f0f0;\n\n      .tool-option {\n        display: flex;\n        flex-direction: column;\n        width: 90px;\n        height: 90px;\n        font-size: 0.75rem;\n        border-radius: 0.375rem;\n        margin: 0px auto 8px auto;\n        cursor: pointer;\n        align-items: center;\n        justify-content: center;\n        padding: 5px;\n      }\n    }\n\n    .tool-bar__container::-webkit-scrollbar {\n      width: 6px; /* Set the width of the scrollbar (Webkit browsers) */\n    }\n\n    .tool-bar__container::-webkit-scrollbar-thumb {\n      background-color: var(--scrollbar-thumb-color);\n      border-radius: 6px; /* Adjust the border-radius to control the appearance */\n    }\n\n    .tool-bar__container::-webkit-scrollbar-track {\n      background-color: var(--scrollbar-track-color);\n    }\n\n    .builder-container {\n      border-radius: 0px 10px 10px 0px;\n      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);\n\n      .filter-node {\n        padding: 0.25rem;\n        border-radius: 0.375rem;\n        width: 250px;\n        background-color: #fff;\n\n        .filter-node__heading {\n          background-color: rgb(253, 224, 71);\n          border-radius: 0.375rem;\n          padding: 4px 8px 4px 8px;\n          text-align: center;\n          color: rgb(202, 138, 4);\n          font-weight: 600;\n        }\n\n        .filter-node__criteria {\n          margin-top: 6px;\n          border: 1px solid #d6e3e3;\n          border-radius: 6px;\n\n          .criteria {\n            padding: 4px;\n\n            .criteria__heading {\n              font-size: 14px;\n            }\n            .criteria-badges {\n              margin-top: 10px;\n              display: flex;\n              flex-wrap: wrap;\n              row-gap: 6px;\n              gap: 6px;\n\n              .badge-criteria,\n              .badge-condition {\n                display: inline-block;\n                border: none;\n                border-radius: 6px;\n                color: #716064;\n                background-color: #eaeaea;\n                line-height: 1.1;\n                align-items: center;\n              }\n\n              .badge-data {\n                display: inline-block;\n                border: none;\n                border-radius: 6px;\n                color: #c7254e;\n                background-color: #f9f2f4;\n                line-height: 1.1;\n                align-items: center;\n                max-width: 100%; /* Limit width to parent's width */\n                overflow: hidden; /* Hide content that overflows */\n                text-overflow: ellipsis; /* Show ellipsis for overflowed text */\n                white-space: nowrap; /* Prevent text wrapping */\n              }\n            }\n          }\n        }\n      }\n\n      .api-request-node {\n        background-color: #fff;\n        padding: 4px;\n        border-radius: 6px;\n        width: 250px;\n\n        .api-request-node__heading {\n          background-color: rgb(252, 165, 165);\n          padding: 4px 8px 4px 8px;\n          text-align: center;\n          color: rgb(220, 38, 38);\n          font-weight: 600;\n        }\n\n        .api-request-node__content {\n          font-size: 14px;\n          text-align: center;\n          padding: 12px;\n          color: #716064;\n\n          .external-api-link {\n            background-color: #eaeaea;\n            border-radius: 4px;\n            word-wrap: break-word;\n          }\n\n          .api-request-handler {\n            margin-top: 12px;\n\n            .success-handler,\n            .error-handler {\n              border: 1px solid #d6e3e3;\n              padding: 4px 8px 4px 8px;\n              border-radius: 999px;\n\n              .handler-text {\n                margin-right: 24px;\n              }\n\n              .handler-text--success {\n                @apply text-green-500;\n              }\n\n              .handler-text--error {\n                @apply text-[#9db5c4];\n              }\n            }\n          }\n        }\n      }\n\n      .carousel-node {\n        padding: 0.25rem;\n        border-radius: 0.375rem;\n        width: 250px;\n        background-color: #fff;\n\n        .carousel-node__heading {\n          background-color: #e047;\n          border-radius: 0.375rem;\n          padding: 4px 8px 4px 8px;\n          text-align: center;\n          color: #fff;\n          font-weight: 600;\n        }\n\n        .carousel-node__content {\n          font-size: 14px;\n          text-align: center;\n          padding: 12px;\n          color: #716064;\n        }\n\n        .carousel-node__slide {\n          margin-top: 6px;\n          border: 1px solid #d6e3e3;\n          border-radius: 6px;\n\n          .slide {\n            padding: 4px;\n\n            .slide__heading {\n              font-size: 14px;\n\n              .slide-number {\n                color: #716064;\n                font-size: 12px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.flow-builder-drawer__container {\n  .drawer-side {\n    right: 0;\n    width: unset;\n    left: unset;\n  }\n}\n\n.flow-builder__drawer {\n  --tw-shadow: 0 10px 15px -3px rgba(182, 180, 180, 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color),\n    0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 red), var(--tw-ring-shadow, 0 0 #0000),\n    var(--tw-shadow);\n\n  .drawer-content {\n    scrollbar-width: thin; /* Display a thin scrollbar (modern browsers) */\n    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-track-color);\n\n    /* Define scrollbar thumb (draggable part) color */\n    --scrollbar-thumb-color: rgb(25 42 81/0.7);\n\n    /* Define scrollbar track (background) color */\n    --scrollbar-track-color: #f0f0f0;\n  }\n\n  .drawer-content::-webkit-scrollbar {\n    width: 6px; /* Set the width of the scrollbar (Webkit browsers) */\n  }\n\n  .drawer-content::-webkit-scrollbar-thumb {\n    background-color: var(--scrollbar-thumb-color);\n    border-radius: 6px; /* Adjust the border-radius to control the appearance */\n  }\n\n  .drawer-content::-webkit-scrollbar-track {\n    background-color: var(--scrollbar-track-color);\n  }\n\n  .add-item__link {\n    font-size: 13px;\n    color: #0097b7;\n    margin: 5px 0px 5px 0px;\n    border-bottom: 1px dotted;\n  }\n\n  .add-item__link:hover {\n    color: #004552;\n    cursor: pointer;\n  }\n\n  .add-component__btn {\n    display: inline-block;\n    margin-top: 24px;\n    width: 100%;\n    border-color: rgba(11, 153, 178, 0.5);\n    background-color: rgba(11, 153, 178, 0.05);\n    color: #0b99b2;\n    border-style: dashed;\n  }\n\n  .add-component__btn:hover {\n    border-color: rgba(11, 153, 178, 0.8);\n    color: #0a849a;\n  }\n\n  .drawer-delete__btn {\n    cursor: pointer;\n    padding: 4px;\n  }\n\n  .drawer-delete__btn:hover {\n    border-radius: 50%;\n    background-color: #e8eaea;\n  }\n\n  .flow-builder__input {\n    font-size: 14px;\n    padding-left: 8px;\n    min-height: 48px;\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid #d9dee8;\n  }\n\n  .flow-builder__input:focus {\n    border-color: #007bff; /* Change the border color */\n    box-shadow: 0 0 0 1px #007bff; /* Add a box shadow */\n    outline: none; /* Remove default outline */\n  }\n}\n",".tooltip-container {\n  position: relative;\n  display: inline-block;\n  z-index: 999999;\n}\n\n.tooltip-container::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  background: #333;\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  top: -35px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  z-index: 1;\n  font-size: x-small;\n  display: none;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n.tooltip-container:hover::after {\n  display: block;\n}\n",".messenger_instance__form {\n    .code_snippet__container {\n        div {\n            overflow: auto !important;\n            padding: 10px;\n        }\n    }\n}",".contact_form {\n  .more_settings:hover {\n    path {\n      @apply transition duration-75;\n      stroke: #fff;\n    }\n  }\n}\n","/* Remove scrollbar arrows for webkit-based browsers (Chrome) */\n.tab-layout_custom-scrollbar::-webkit-scrollbar {\n  width: 16px;\n  overflow-x: auto;\n}\n\n.tab-layout_custom-scrollbar::-webkit-scrollbar-track {\n  background: #fbfbfb;\n}\n\n.tab-layout_custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #192a51;\n}\n\n.inbox_custom-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.inbox-upload_image {\n  &:hover {\n    svg,\n    g {\n      stroke: #192a51 !important;\n    }\n  }\n}\n\n.inbox-emoji_picker {\n  &:hover {\n    svg,\n    g {\n      stroke: #192a51 !important;\n    }\n  }\n}\n\n.clear-attachment-icon {\n  color: black;\n  font-size: 2rem;\n  position: absolute;\n  top: 2px;\n  left: -61px;\n  transform: translate(50%, -50%);\n  cursor: pointer;\n  z-index: 2;\n  -ms-transform: translate(-50%, -50%);\n}\n\n.user-Template__btn-row {\n  .btn__icon-color {\n    &:hover {\n      svg,\n      g {\n        stroke: white !important;\n      }\n    }\n  }\n  .template-btn__icon-color {\n    svg,\n    g {\n      stroke: white;\n    }\n  }\n  .case-btn__icon-color {\n    &:hover {\n      svg,\n      g,\n      path {\n        stroke: white !important;\n      }\n    }\n  }\n}\n\n.active_tab {\n  path {\n    stroke: #fff;\n  }\n}\n","/* Remove scrollbar arrows for webkit-based browsers (Chrome) */\n.chat-preview_custom-scrollbar::-webkit-scrollbar {\n  width: 16px;\n}\n\n.chat-preview_custom-scrollbar::-webkit-scrollbar-track {\n  background: #9f9f9f;\n}\n\n/* Remove scrollbar arrows for Firefox */\n.chat-preview_custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #f4f4f4;\n}\n\n.inbox_custom-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n","@media (max-width: 1366px) {\n  .case-Management__hide-on-large-screens {\n    display: none;\n  }\n}\n\n@media (min-width: 1366px) {\n  .case-Management-drawer__hide-on-large-screens {\n    display: none;\n  }\n}\n",".role_permission__form {\n  .main-heading {\n    color: var(--Space-Cadet-Blue, #192a51);\n\n    /* Tabular_Heading_PT_Sans_Caption16 */\n    font-family: PT Sans Caption;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n\n  .permission-heading {\n    color: var(--Space-Cadet-Blue, #192a51);\n    /* Tabular_Heading_PT_Sans_Caption16 */\n    font-family: PT Sans Caption;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n}\n\n.role-permission__container {\n  .role-permission__card {\n    padding: 20px 34px 20px 34px;\n    border-radius: 10px;\n    background: var(--White, #fff);\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25);\n  }\n  .module-name {\n    color: var(--Raisin-Black, #262525);\n    font-family: PT Sans Caption;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n\n  .role-type {\n    color: var(--Raisin-Black, #262525);\n    font-family: Lato;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: -0.32px;\n  }\n\n  .role__card {\n    padding: 20px 5px 20px 5px;\n  }\n}\n",".layout {\n  display: flex;\n}\n\n.main-container {\n  display: flex;\n  flex: 1;\n  margin-top: 80px;\n}\n\n.navbar {\n  height: $nav_bar_height;\n  position: fixed !important;\n  z-index: 500;\n}\n\n.content {\n  flex-grow: 1;\n  overflow-y: auto;\n  background-color: #f4f4f4;\n}\n\n.sidebar {\n  &.bar_open {\n    min-width: 17rem;\n    max-width: 17rem;\n  }\n\n  .sidebar_content {\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    z-index: -999;\n  }\n\n  @media (min-width: $rg) {\n    min-height: calc(100vh - #{$nav_bar_height});\n  }\n\n  @media (max-width: $rg) {\n    height: 100vh;\n  }\n\n  .nav_link {\n    min-width: 240px;\n    @apply transition ease-in-out text-independenceBlue bg-brightGray border hover:bg-spaceCadetBlue hover:text-white px-5 py-2.5 flex rounded-xl items-center md:cursor-pointer cursor-default duration-200 font-medium;\n  }\n\n  .nav_link-sub_menu {\n    min-width: 240px;\n    @apply text-independenceBlue hover:bg-spaceCadetBlue bg-brightGray border hover:text-white px-5 py-2.5 flex rounded-xl md:cursor-pointer cursor-default font-medium transition ease-in-out duration-200;\n  }\n\n  .sub_menu {\n    @apply transition ease-in-out delay-150 duration-300 p-2.5 flex rounded-t-xl md:cursor-pointer cursor-default font-medium;\n  }\n\n  .active {\n    @apply transition-none hover:-translate-x-0 bg-spaceCadetBlue text-white;\n  }\n\n  .nav_content:hover {\n    @apply -translate-x-1 transition duration-75;\n  }\n\n  .is_active {\n    @apply bg-spaceCadetBlue;\n    color: #fff;\n\n    svg {\n      // @apply transition ease-in-out duration-200;\n      transition-delay: 25ms;\n      color: #fff !important;\n      stroke: #fff !important;\n    }\n\n    path {\n      // @apply transition ease-in-out duration-200;\n      transition-delay: 25ms;\n      stroke: #fff !important;\n      color: #fff !important;\n    }\n  }\n\n  .menu_common {\n    gap: 10px;\n    transition-delay: 25ms;\n\n    .icon {\n      max-width: 20px;\n    }\n\n    &:hover {\n      svg {\n        // @apply transition ease-in-out duration-200;\n        transition-delay: 25ms;\n        color: #fff !important;\n        stroke: #fff !important;\n      }\n\n      path {\n        // @apply transition ease-in-out duration-200;\n        transition-delay: 25ms;\n        stroke: #fff !important;\n        color: #fff !important;\n      }\n    }\n  }\n}\n\n.page {\n  padding: 25px 35px;\n}\n\n.public_page {\n  padding: 0;\n}\n","$nav_bar_height: 80px;\n$side_bar_width: 14rem;\n\n$xxs: 320px;\n$xs: 375px;\n$sm: 425px;\n$srg: 640px;\n$rg: 768px;\n$xrg: 864px;\n$md: 1024px;\n$lg: 1366px;\n$xl: 1536px;\n$twoXl: 1920px;\n$threeXl: 2560px;\n",".drawer-side {\n  z-index: 999 !important;\n}\n\n.overlay {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  opacity: 0.1;\n  transition: 0.3s ease;\n  background-color: transparent;\n}\n\n.overlay:hover {\n  opacity: 0.9;\n}\n\n.tab.tab-active:not(.tab-disabled):not([disabled]) {\n  background-color: #192a51;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
